/* ============================================================
   SR PACKAGING — THEME JS
   Initialised after DOM ready. No external dependencies.
   ============================================================ */

(function () {
  'use strict';

  /* ── UTIL ─────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  /* ── 1. PARALLAX HERO ──────────────────────────────────────
     v59: Differential rates — image moves faster than text so
     the text feels almost static while the image "floats" past.
     Intensity controlled by data-sr-parallax (0–100) on .sr-hero.
     0 = off. 60 (default) = image rate ~0.18 / text rate ~-0.04
     (text drifts slightly opposite for a stuck-in-place feel).
  ────────────────────────────────────────────────────────── */
  function initParallax() {
    var heroes = qsa('.sr-hero');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    heroes.forEach(function (hero) {
      var intensity = parseInt(hero.getAttribute('data-sr-parallax') || '60', 10);
      if (isNaN(intensity)) intensity = 60;
      if (intensity <= 0 || reduced) return;

      var scale = intensity / 100;
      // v60.8: stronger parallax — image floats more, text drifts more pronounced
      var imgRate  = 0.55 * scale;   // image moves with scroll (faster than page → feels like it floats)
      var textRate = -0.12 * scale;  // text drifts the opposite way — feels "anchored" against the image

      // Per-slide we apply transforms to the bg image AND the content block
      var slides = qsa('.sr-hero__slide', hero);
      var pairs = slides.map(function (slide) {
        return {
          bg:   qs('.sr-hero__bg', slide),
          text: qs('.sr-hero__content', slide)
        };
      });

      var ticking = false;
      function update() {
        ticking = false;
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
        // raw = how far past the top of the viewport the hero has scrolled
        var raw = -rect.top;
        var imgOff  = Math.round(raw * imgRate);
        var textOff = Math.round(raw * textRate);
        pairs.forEach(function (p) {
          if (p.bg)   p.bg.style.transform   = 'translate3d(0,' + imgOff  + 'px,0) scale(1.08)';
          if (p.text) p.text.style.transform = 'translate3d(0,' + textOff + 'px,0)';
        });
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  /* ── 2. HERO SLIDER ────────────────────────────────────────
     Manual swipe/drag + arrow buttons. v59: optional auto-rotate
     driven by data-sr-auto / data-sr-interval on the .sr-hero
     element. Pauses on hover, swipe, tab-hidden, and out-of-view.
  ────────────────────────────────────────────────────────── */
  function initHeroSlider() {
    qsa('.sr-hero').forEach(function (hero) {
      var track  = qs('.sr-hero__slides', hero);
      var slides = qsa('.sr-hero__slide', hero);
      var pips   = qsa('.sr-pip', hero);
      var prev   = qs('.sr-hero__arrow--prev', hero);
      var next   = qs('.sr-hero__arrow--next', hero);
      if (!track || slides.length < 2) return;

      var cur = 0;
      var startX = 0;
      var dragging = false;

      var auto = hero.getAttribute('data-sr-auto') === 'true';
      var intervalSec = parseInt(hero.getAttribute('data-sr-interval') || '6', 10);
      if (!intervalSec || intervalSec < 2) intervalSec = 6;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var inView = true;
      var hovered = false;

      function goTo(idx) {
        cur = (idx + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        pips.forEach(function (p, i) { p.classList.toggle('active', i === cur); });
      }

      function startAuto() {
        stopAuto();
        if (!auto || reduced || hovered || !inView || document.hidden) return;
        timer = setInterval(function () { goTo(cur + 1); }, intervalSec * 1000);
      }
      function stopAuto() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function bumpAuto() { stopAuto(); startAuto(); }

      on(prev, 'click', function () { goTo(cur - 1); bumpAuto(); });
      on(next, 'click', function () { goTo(cur + 1); bumpAuto(); });

      on(hero, 'mouseenter', function () { hovered = true; stopAuto(); });
      on(hero, 'mouseleave', function () { hovered = false; startAuto(); });

      // Touch
      on(hero, 'touchstart', function (e) {
        stopAuto();
        startX = e.touches[0].clientX;
        dragging = true;
      }, { passive: true });
      on(hero, 'touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
        bumpAuto();
      });
      // Pointer (desktop drag)
      on(hero, 'pointerdown', function (e) { stopAuto(); startX = e.clientX; dragging = true; });
      on(hero, 'pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
        bumpAuto();
      });

      // Pause on tab hide
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto();
        else startAuto();
      });

      // Pause when scrolled out of view
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView) startAuto();
            else stopAuto();
          });
        }, { threshold: 0.2 });
        io.observe(hero);
      }

      goTo(0);
      startAuto();
    });
  }

  /* ── 3. CATEGORY L1 TRAY TOGGLE ───────────────────────────
     Tray is embedded inside the card.
     Mobile (<768px): tap = navigate directly to L0 collection URL.
     Desktop (>=768px): tap = open inline tray; click L1 cards to navigate.
  ────────────────────────────────────────────────────────── */
  function isMobileViewport() {
    return window.matchMedia
      ? window.matchMedia('(max-width: 767px)').matches
      : (window.innerWidth || document.documentElement.clientWidth) < 768;
  }

  function initCategoryTrays() {
    qsa('.sr-cc[data-tray]').forEach(function (card) {
      if (card.dataset.srTrayInit) return;
      card.dataset.srTrayInit = '1';

      var trayId = card.getAttribute('data-tray');
      var tray   = document.getElementById(trayId);
      var directUrl = card.getAttribute('data-collection-url');
      if (!tray) return;

      function toggleTray() {
        var isOpen = tray.classList.contains('sr-open');
        qsa('.sr-l1.sr-open').forEach(function (t) {
          if (t !== tray) {
            t.classList.remove('sr-open');
            var p = t.closest('.sr-cc');
            if (p) p.classList.remove('sr-cc--open');
          }
        });
        tray.classList.toggle('sr-open', !isOpen);
        card.classList.toggle('sr-cc--open', !isOpen);
        card.setAttribute('aria-expanded', String(!isOpen));
      }

      on(card, 'click', function (e) {
        // Inside tray children — let the link work
        if (e.target.closest('.sr-l1__card, .sr-l1__viewall, .sr-l1__row')) return;

        // Mobile: direct-navigate to L0 URL, never open tray
        if (isMobileViewport() && directUrl) {
          e.preventDefault();
          window.location.href = directUrl;
          return;
        }

        // Desktop: empty area inside open tray closes it
        if (e.target.closest('.sr-l1') && tray.classList.contains('sr-open')) {
          e.preventDefault();
          toggleTray();
          return;
        }

        e.preventDefault();
        toggleTray();
      });

      on(card, 'keydown', function (e) {
        if (e.target.closest('.sr-l1')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (isMobileViewport() && directUrl) {
            window.location.href = directUrl;
          } else {
            toggleTray();
          }
        }
      });
    });
  }

  /* ── 4. BRAND MARQUEE GLOW ─────────────────────────────────
     Cycle through brand name chips, lighting one up every 1.5s.
  ────────────────────────────────────────────────────────── */
  function initMarqueeGlow() {
    qsa('.sr-marq__track').forEach(function (track) {
      var chips = qsa('.sr-mchip', track);
      if (!chips.length) return;
      var half = Math.floor(chips.length / 2);
      var idx  = 0;
      setInterval(function () {
        chips.forEach(function (c) { c.classList.remove('sr-lit'); });
        chips[idx % half].classList.add('sr-lit');
        if (chips[idx % half + half]) chips[idx % half + half].classList.add('sr-lit');
        idx = (idx + 1) % half;
      }, 1500);
    });
  }

  /* ── 5. PACK SELECTOR ──────────────────────────────────────
     Reads data attributes from buttons. Updates:
       - main price display (#sr-price-main)
       - MRP display (#sr-price-mrp)
       - save badge (#sr-price-save)
       - ATC button text (#sr-atc-btn)
       - bulk table highlighted row (highlight .sr-br[data-pack])
     Also updates the hidden Shopify variant input if present.
  ────────────────────────────────────────────────────────── */
  /* v60.9: Global ATC available for ALL products — slab or not.
     For non-slab products, atcPayload falls back to {vid: defaultVid,
     qty: stepper}. For slab products, the per-grid wiring in
     initPackSelector overrides with slab-aware {vid, qty}. */
  window.SrTheme = window.SrTheme || {};
  window.SrTheme.atcPayload = window.SrTheme.atcPayload || function (defaultVid) {
    var stepper = document.getElementById('sr-qty-val');
    var qty = stepper ? Math.max(1, parseInt(stepper.value, 10) || 1) : 1;
    return { vid: parseInt(defaultVid, 10) || 0, qty: qty };
  };

  /* v60.12: Shared cart-add core. Used by both outer fallback and the
     inner slab-aware override. Two paths:
     1) Paper's app.addCartItem (works with Paper's reactive cart state)
     2) Direct fetch /cart/add.js (used when Paper isn't available OR
        when we have file/properties to send)
     After EITHER, we:
       - Re-fetch /cart.js to get authoritative cart state
       - Update visible cart bubble (recursive text-node walk)
       - Force the SR toast via window.srCartToast.showFor
       - Open Paper's cart drawer if available */
  function srFindPaperApp() {
    try {
      var nodes = [document.querySelector('[x-data*="app()"]'), document.documentElement, document.body];
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i];
        if (r && r._x_dataStack && r._x_dataStack[0]) return r._x_dataStack[0];
        if (r && r.__x && r.__x.$data) return r.__x.$data;
      }
    } catch (e) {}
    return null;
  }
  function srUpdateCartBubble(count) {
    var sels = ['[data-cart-count]', '.header__cart-count', '.cart-icon-bubble', '[class*="cart-count"]', '[class*="cart_count"]', '[class*="cart-bubble"]'];
    sels.forEach(function (sel) {
      qsa(sel).forEach(function (el) {
        // Find the deepest text node containing digits/empty and update it
        function walk(node) {
          for (var i = 0; i < node.childNodes.length; i++) {
            var n = node.childNodes[i];
            if (n.nodeType === 3) { n.nodeValue = String(count); return true; }
            if (n.nodeType === 1 && walk(n)) return true;
          }
          return false;
        }
        if (!walk(el)) el.textContent = String(count);
      });
    });
  }
  function srPostAddSuccess(variantId, btn, origLabel) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        console.log('[SR atc] cart now', cart.item_count, 'items');
        srUpdateCartBubble(cart.item_count);
        try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart })); } catch (e) {}
        // Force the SR toast (instead of relying on the auto-diff IIFE that
        // sometimes misses fast adds)
        if (window.srCartToast && typeof window.srCartToast.showFor === 'function') {
          setTimeout(function () { window.srCartToast.showFor(variantId); }, 100);
        }
        var app = srFindPaperApp();
        if (app) {
          try { if (typeof app.updateCart === 'function') app.updateCart(true); } catch (e) {}
          try {
            if (typeof app.openCart === 'function') app.openCart();
            else if (typeof app.toggleCart === 'function') app.toggleCart(true);
          } catch (e) {}
        }
        if (btn) {
          btn.textContent = 'Added ✓';
          btn.style.background = '#3B6D11';
          setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; btn.disabled = false; }, 1400);
        }
      }).catch(function (e) { console.warn('[SR atc] cart refresh failed', e); });
  }
  function srPostAddError(err, btn, origLabel) {
    console.error('[SR atc] failed:', err);
    if (btn) {
      btn.textContent = (err && err.message) ? String(err.message).slice(0, 42) : 'Failed';
      btn.style.background = '#A32D2D';
      setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; btn.disabled = false; }, 2800);
    }
  }
  function srBuildFormData(vid, qty) {
    var fd = new FormData();
    fd.append('id', String(vid));
    fd.append('quantity', String(qty));
    var remarksEl = document.querySelector('textarea[name="properties[Remarks]"]');
    if (remarksEl && remarksEl.value && remarksEl.value.trim()) {
      fd.append('properties[Remarks]', remarksEl.value.trim());
    }
    var fileEl = document.querySelector('input[type="file"][name="properties[Custom Design]"]');
    if (fileEl && fileEl.files && fileEl.files[0]) {
      fd.append('properties[Custom Design]', fileEl.files[0]);
    }
    /* v60.99 #9: MTO products get a line-item property so Shiprocket
       Checkout can drop COD. srSyncMtoFlag() also mirrors it to a cart
       attribute. PDP MTO products carry the .sr-mto element. */
    if (document.querySelector('.sr-mto')) {
      fd.append('properties[Made to order]', 'Yes');
    }
    return { fd: fd, hasFile: !!(fileEl && fileEl.files && fileEl.files[0]) };
  }
  /* v60.13: ATC simplified — ALWAYS use direct fetch to /cart/add.js.
     Skipped Paper's app.addCartItem entirely because it was the source
     of intermittent failures (race conditions with Alpine init, plus it
     ignores line-item properties for files/remarks).
     One path, one outcome. Hard navigation fallback on fetch failure. */
  function srCartAdd(p, btn, origLabel) {
    // MTO MOQ check
    var mtoEl = document.querySelector('.sr-mto');
    if (mtoEl) {
      var moq = parseInt(mtoEl.getAttribute('data-sr-moq'), 10) || 0;
      if (moq > 0 && p.qty < moq) {
        if (btn) {
          btn.textContent = 'MOQ is ' + moq + ' units';
          btn.style.background = '#A32D2D';
          setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; btn.disabled = false; }, 2200);
        }
        return;
      }
    }
    var built = srBuildFormData(p.vid, p.qty);
    console.log('[SR atc] POST /cart/add.js', { vid: p.vid, qty: p.qty });

    fetch('/cart/add.js', {
      method: 'POST',
      body: built.fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (res) {
      console.log('[SR atc] /cart/add.js →', res.status);
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || err.message || ('Shopify returned ' + res.status));
        });
      }
      return res.json();
    }).then(function (line) {
      console.log('[SR atc] line added id=' + (line && line.id));
      srPostAddSuccess(p.vid, btn, origLabel);
    }).catch(function (err) {
      console.error('[SR atc] fetch failed:', err);
      // Hard fallback: navigate to /cart/add (browser handles POST + cookie + redirect)
      // Only used when fetch path errors out, so successful adds don't trigger nav
      if (btn) {
        btn.textContent = (err && err.message) ? String(err.message).slice(0, 42) : 'Adding via fallback…';
        btn.style.background = '#A32D2D';
      }
      // Wait 500ms so user sees the error briefly, then try navigation fallback
      setTimeout(function () {
        try {
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart/add';
          form.style.display = 'none';
          var idIn = document.createElement('input'); idIn.name = 'id'; idIn.value = String(p.vid); form.appendChild(idIn);
          var qIn = document.createElement('input');  qIn.name = 'quantity'; qIn.value = String(p.qty); form.appendChild(qIn);
          // Carry properties via the form
          var rem = document.querySelector('textarea[name="properties[Remarks]"]');
          if (rem && rem.value.trim()) {
            var pIn = document.createElement('input'); pIn.name = 'properties[Remarks]'; pIn.value = rem.value.trim(); form.appendChild(pIn);
          }
          document.body.appendChild(form);
          form.submit();  // Native POST → /cart/add → redirects to /cart
        } catch (e) {
          console.error('[SR atc] navigation fallback failed too', e);
          if (btn) { btn.disabled = false; btn.textContent = origLabel; btn.style.background = ''; }
        }
      }, 1200);
    });
  }

  window.SrTheme.atc = window.SrTheme.atc || function (defaultVid) {
    var p = window.SrTheme.atcPayload(defaultVid);
    var btn = document.getElementById('sr-atc-btn');
    var origLabel = btn ? btn.textContent : 'Add to Cart';
    console.log('[SR atc-outer] click', p);
    if (!p.vid || p.qty < 1) { srPostAddError(new Error('Pick variant/qty'), btn, origLabel); return; }
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    srCartAdd(p, btn, origLabel);
  };

  window.srAtcClick = window.srAtcClick || function () {
    var btn = document.getElementById('sr-atc-btn');
    var def = btn ? parseInt(btn.getAttribute('data-sr-default-vid'), 10) : 0;
    if (!def) {
      var vinp = document.querySelector('input[name="id"]');
      def = vinp ? parseInt(vinp.value, 10) : 0;
    }
    window.SrTheme.atc(def);
  };

  /* v60.15 srAtcGo — OUR OWN cart-add path with maximum visibility.
     We've been losing to Paper's silent error_alert (which we hid via
     CSS for the success toast — same flag is used for errors too).
     This function:
       1) Computes the payload (slab-aware via SrTheme.atcPayload)
       2) Enforces MOQ for MTO products
       3) POSTs directly to /cart/add.js
       4) Logs every step to console
       5) On success: calls Paper's updateCart, shows toast, "Added ✓"
       6) On HTTP/network failure: shows the actual error on the button
          AND alerts so customer cannot miss it
       7) After 1.6s of success with NO visible cart change, falls back
          to navigating to /cart so customer definitively sees items. */
  window.srAtcGo = function () {
    var btn = document.getElementById('sr-atc-btn');

    /* v55.26: cart-aware PDP guard. Once the CTA is in View Cart state,
       clicking it must never run another add-to-cart request. This also
       covers the short window immediately after /cart/add.js succeeds but
       before the cart-mirror has finished syncing lastCartQty. */
    if (btn && btn.getAttribute('data-sr-pdp-incart') === '1') {
      if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) return; window.location.href = '/cart';
      return;
    }

    var origLabel = btn ? btn.textContent : 'Add to cart';
    var defaultVid = btn ? parseInt(btn.getAttribute('data-sr-default-vid'), 10) : 0;

    /* v60.16: INLINE payload computation — earlier we depended on
       SrTheme.atcPayload which was set inside an initPackSelector
       closure. Whenever that closure didn't run (timing / no grid /
       redefine race), the outer fallback returned qty=1 regardless
       of what slab was clicked. Inlining the DOM read here removes
       all that fragility. */
    console.log('[SR atc-go v60.22] click handler firing');
    var p = { vid: defaultVid, qty: 1 };
    var grid = document.querySelector('.sr-pack-grid');
    if (grid) {
      var tierMode = grid.getAttribute('data-tier-mode') || 'variant-direct';
      var smallestTier = parseInt(grid.getAttribute('data-smallest-tier-max'), 10) || 0;
      var selTile = grid.querySelector('.sr-pb.sr-sel') || grid.querySelector('.sr-pb');
      console.log('[SR atc-go] tier-mode:', tierMode, 'smallest tier:', smallestTier);

      if (selTile) {
        if (selTile.classList.contains('sr-pb--custom')) {
          /* v60.22 Custom — TIER-RATE algorithm:
             1) User types N
             2) Find variant whose tier_max >= N (first that fits)
                If N > all, use the largest tier (highest qty has best rate)
             3) Ceil N up to multiple of smallest tier
             4) Cart add: qty = ceiled_N of that variant */
          var customInput = document.querySelector('.sr-custom-qty-input');
          var typedN = customInput ? parseInt(customInput.value, 10) || 0 : 0;
          if (!typedN) {
            alert('Please enter a custom quantity first.');
            if (customInput) customInput.focus();
            return;
          }

          if (tierMode === 'tier-rate') {
            // Collect tiles in their rendered order (smallest tier first)
            var tiles = qsa('.sr-pb:not(.sr-pb--custom)', grid);
            var tiers = tiles.map(function (t) {
              return {
                max: parseInt(t.getAttribute('data-tier-max'), 10) || 0,
                vid: parseInt(t.getAttribute('data-variant-id'), 10) || 0
              };
            }).filter(function (x) { return x.max > 0 && x.vid > 0; });
            tiers.sort(function (a, b) { return a.max - b.max; });

            if (!tiers.length) { alert('No tier variants configured.'); return; }

            // Find tier: first tier_max >= N, else last (largest)
            var matched = null;
            for (var i = 0; i < tiers.length; i++) {
              if (tiers[i].max >= typedN) { matched = tiers[i]; break; }
            }
            if (!matched) matched = tiers[tiers.length - 1];

            // Ceil N to multiple of smallest tier
            var smallest = tiers[0].max;
            var ceiledN = Math.max(smallest, Math.ceil(typedN / smallest) * smallest);

            p.vid = matched.vid;
            p.qty = ceiledN;
            console.log('[SR atc-go] Custom tier-rate: typed=' + typedN + ' → variant=' + matched.vid + ' (tier_max=' + matched.max + ') × qty=' + ceiledN);
          } else {
            // variant-direct fallback — add typed qty of the default variant
            p.qty = typedN;
            console.log('[SR atc-go] Custom variant-direct: qty=' + typedN);
          }
        } else {
          /* Pack tile click — v62.12: counter (#sr-qty-val) now holds UNIT
             count directly (synced to packQty on slab click via sr-pack-
             selector.liquid). Multiplying by packQty again caused ₹6,01,200
             instead of ₹2,004 for one pack of 300 at ₹6.68/unit. Use the
             stepper value as-is. */
          var tileVid = selTile.getAttribute('data-variant-id');
          if (tileVid) p.vid = parseInt(tileVid, 10) || p.vid;
          var stepper = document.getElementById('sr-qty-val');
          var stepperVal = stepper ? (parseInt(stepper.value, 10) || 0) : 0;
          /* v61.x: enforce the pack floor + snap to slab multiples so a MANUALLY
             typed sub-slab quantity (e.g. 50 when the pack is 100) can never be
             added. Uses the selected tile's slab, falling back to the smallest tier.
             Mirrors the +/- step, so typing and stepping agree. */
          var slabUnit = parseInt(
            grid.getAttribute('data-smallest-tier-max') ||
            grid.getAttribute('data-first-slab') ||
            '1', 10) || 1;
          if (slabUnit > 1) {
            stepperVal = Math.max(slabUnit, Math.round(stepperVal / slabUnit) * slabUnit);
          } else {
            stepperVal = Math.max(1, stepperVal);
          }
          if (stepper && (parseInt(stepper.value, 10) || 0) !== stepperVal) {
            stepper.value = stepperVal;   // reflect the snap in the visible box
            try { stepper.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
          }
          p.qty = stepperVal;
          /* v61.x: RATE FOLLOWS QUANTITY. Re-select the tier variant whose
             tier_max >= qty (first that fits); for qty beyond the largest tier,
             use the largest (best-rate) tier. Same rule as the Custom box, so
             stepping and typing get the correct tier price. tier-rate only;
             variant-direct keeps the selected tile's variant. */
          if ((grid.getAttribute('data-tier-mode') || '') === 'tier-rate') {
            var tRates = qsa('.sr-pb:not(.sr-pb--custom)', grid).map(function (t) {
              return { max: parseInt(t.getAttribute('data-tier-max'), 10) || 0, vid: parseInt(t.getAttribute('data-variant-id'), 10) || 0 };
            }).filter(function (x) { return x.max > 0 && x.vid > 0; });
            tRates.sort(function (a, b) { return a.max - b.max; });
            if (tRates.length) {
              var mtch = null;
              for (var ri = 0; ri < tRates.length; ri++) { if (tRates[ri].max >= stepperVal) { mtch = tRates[ri]; break; } }
              if (!mtch) mtch = tRates[tRates.length - 1];
              p.vid = mtch.vid;
              console.log('[SR atc-go] rate follows qty → variant=' + mtch.vid + ' (tier_max=' + mtch.max + ') for qty=' + stepperVal);
            }
          }
          console.log('[SR atc-go] Pack tile: stepper (units, slab-snapped) = ' + p.qty);
        }
      }
    } else {
      var ns = document.getElementById('sr-qty-val');
      if (ns) p.qty = Math.max(1, parseInt(ns.value, 10) || 1);
    }

    console.log('[SR atc-go] FINAL payload:', p);

    if (!p.vid || p.qty < 1) {
      console.warn('[SR atc-go] invalid payload', p);
      alert('Please select a pack size or enter a quantity before adding to cart.');
      return;
    }

    // MTO MOQ check
    var mtoEl = document.querySelector('.sr-mto');
    if (mtoEl) {
      var moq = parseInt(mtoEl.getAttribute('data-sr-moq'), 10) || 0;
      if (moq > 0 && p.qty < moq) {
        if (btn) {
          btn.textContent = 'MOQ is ' + moq + ' units';
          btn.style.background = '#A32D2D';
          setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 2400);
        }
        return;
      }
    }

    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; btn.style.background = ''; }

    var fd = new FormData();
    fd.append('id', String(p.vid));
    fd.append('quantity', String(p.qty));
    var rem = document.querySelector('textarea[name="properties[Remarks]"]');
    if (rem && rem.value && rem.value.trim()) fd.append('properties[Remarks]', rem.value.trim());
    var fileEl = document.querySelector('input[type="file"][name="properties[Custom Design]"]');
    if (fileEl && fileEl.files && fileEl.files[0]) fd.append('properties[Custom Design]', fileEl.files[0]);
    if (document.querySelector('.sr-mto')) fd.append('properties[Made to order]', 'Yes'); /* v60.99 #9 */
    /* v63.23: stash MOQ as a hidden line-item property (underscore prefix
       → hidden in cart UI). srCartStep reads it to enforce "drop to 0 if
       below MOQ" on the cart page +/- buttons. */
    if (mtoEl) {
      var _mqq = parseInt(mtoEl.getAttribute('data-sr-moq'), 10) || 0;
      if (_mqq > 0) fd.append('properties[_sr_moq]', String(_mqq));
    }

    console.log('[SR atc-go] POST /cart/add.js id=' + p.vid + ' qty=' + p.qty);

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (res) {
      console.log('[SR atc-go] response status', res.status);
      return res.text().then(function (txt) {
        var json = {};
        try { json = JSON.parse(txt); } catch (e) {}
        console.log('[SR atc-go] response body', json);
        if (!res.ok) {
          var msg = json.description || json.message || ('Server returned ' + res.status);
          throw new Error(msg);
        }
        return json;
      });
    }).then(function (line) {
      console.log('[SR atc-go] SUCCESS line id=' + (line && line.id) + ' qty=' + (line && line.quantity));

      /* v63.37: make the PDP action feel instant. The cart response sync
         below remains the source of truth, but the primary CTA can become
         View Cart immediately after Shopify confirms /cart/add.js. */
      if (btn) {
        btn.disabled = false;
        btn.setAttribute('data-sr-pdp-incart', '1');
        if (typeof window.srSetPdpIncartUi === 'function') { try { window.srSetPdpIncartUi(true); } catch(e){} }
        window.srPdpIncartLockUntil = Date.now() + 3000;
        btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;justify-content:center;width:100%;"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7.5L6 10.5L11.5 4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>View Cart<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="M2 5.5H9M9 5.5L6 2.5M9 5.5L6 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      }
      var srQtyInp = document.getElementById('sr-qty-val');
      if (srQtyInp && line && line.quantity) {
        srQtyInp.value = String(line.quantity);
        try { srQtyInp.dispatchEvent(new Event('input', { bubbles: true })); } catch(e) {}
      }

      /* v63.30 — BULLETPROOF + fast. We fetch /cart.js exactly ONCE, then
         drive Alpine + the count badges + the PDP mirror + the cart drawer
         from that single response. The old path did three round-trips
         (/cart/add.js + Paper's updateCart() second /cart.js + a manual
         third /cart.js for the badge) — gone now. */
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (cart) {
          console.log('[SR atc-go] cart now has', cart.item_count, 'items');

          // 1. Sync Alpine cart state directly from the response (no second /cart.js fetch)
          if (typeof window.srSyncAlpineFromCart === 'function') {
            try { window.srSyncAlpineFromCart(cart); } catch (e) {}
          }

          // 2. Manually refresh any non-Alpine cart-count nodes (legacy header bubbles, mobile bar)
          var sels = ['[data-cart-count]','.header__cart-count','[class*="cart-count"]','[class*="cart_count"]','[class*="cart-bubble"]'];
          sels.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
              function walk(node) {
                for (var i = 0; i < node.childNodes.length; i++) {
                  var n = node.childNodes[i];
                  if (n.nodeType === 3) { n.nodeValue = String(cart.item_count); return true; }
                  if (n.nodeType === 1 && walk(n)) return true;
                }
                return false;
              }
              if (!walk(el)) el.textContent = String(cart.item_count);
            });
          });

          // 3. Open the cart drawer (Paper behaviour) without an extra fetch.
          try {
            var root = document.querySelector('[x-data*="app()"]') || document.documentElement;
            var app = (root && root._x_dataStack && root._x_dataStack[0]) ||
                      (root && root.__x && root.__x.$data) || null;
            if (app) {
              var openDrawer = (window.innerWidth < 768) ? (app.cart_behavior_mobile) : (app.cart_behavior_desktop);
              if (openDrawer === 'drawer') { app.cart_drawer = true; }
              else if (openDrawer === 'alert') { app.cart_alert = true; }
              /* skip "redirect" — that's the navigate-to-/cart behaviour */
            }
          } catch (e) {}

          // 4. Broadcast for tile pills + PDP cart-mirror (they read detail.cart, no fetch)
          if (typeof window.srBroadcastCart === 'function') {
            try { window.srBroadcastCart(cart); } catch(e){}
          } else {
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            } catch(e){}
          }

          // 5. Toast
          if (window.srCartToast && typeof window.srCartToast.showFor === 'function') {
            try { window.srCartToast.showFor(p.vid); } catch (e) {}
          }
        });

      if (btn) {
        btn.textContent = 'Added ✓';
        btn.style.background = '#3B6D11';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = origLabel;
          btn.style.background = '';
        }, 1800);
      }
    }).catch(function (err) {
      console.error('[SR atc-go] FAILED:', err);
      var msg = err.message || 'Unknown error';
      var isMto = !!document.querySelector('.sr-mto');
      var isInventoryError = /availab|stock|inventory|sold out|were added/i.test(msg);

      /* v60.19: For MTO products, NEVER show the modal alert. Inventory
         errors are usually partial-adds (Shopify adds what it can, returns 422).
         Just re-fetch the cart silently and either:
           - show "Added ✓" if the line was added (partial-add success)
           - show "Out of stock" briefly on the button (no alert popup) */
      if (isMto && isInventoryError) {
        console.log('[SR atc-go] MTO + inventory error, checking partial add silently');
        fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var lineFound = false;
            for (var i = 0; i < (cart.items || []).length; i++) {
              if (String(cart.items[i].variant_id) === String(p.vid)) { lineFound = true; break; }
            }
            if (lineFound) {
              console.log('[SR atc-go] MTO partial add succeeded — treating as success');
              srPostAddSuccessForMto(p.vid, cart, btn, origLabel);
            } else {
              // True 0-add — show brief button state, NO alert
              if (btn) {
                btn.textContent = 'Out of stock';
                btn.style.background = '#A32D2D';
                btn.disabled = false;
                setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 3500);
              }
            }
          })
          .catch(function () {
            // Fetch failed — still don't alert, just brief button state
            if (btn) {
              btn.textContent = 'Out of stock';
              btn.style.background = '#A32D2D';
              btn.disabled = false;
              setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 3500);
            }
          });
        return;
      }

      if (btn) {
        btn.textContent = msg.slice(0, 48);
        btn.style.background = '#A32D2D';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 4000);
      }
      alert('Could not add to cart:\n\n' + msg + '\n\nPress F12 for full details in the browser console.');
    });
  };

  /* v60.18/19 helper: post-success UI updates when MTO has a partial add */
  function srPostAddSuccessForMto(variantId, cart, btn, origLabel) {
    qsa('[data-cart-count],[class*="cart-count"],[class*="cart_count"],[class*="cart-bubble"]').forEach(function (el) {
      function walk(n){for(var i=0;i<n.childNodes.length;i++){var c=n.childNodes[i];if(c.nodeType===3){c.nodeValue=String(cart.item_count);return true;}if(c.nodeType===1&&walk(c))return true;}return false;}
      if(!walk(el)) el.textContent = String(cart.item_count);
    });
    if (window.srCartToast && typeof window.srCartToast.showFor === 'function') {
      setTimeout(function () { try { window.srCartToast.showFor(variantId); } catch (e) {} }, 100);
    }
    try {
      var root = document.querySelector('[x-data*="app()"]') || document.documentElement;
      var app = (root && root._x_dataStack && root._x_dataStack[0]) || (root && root.__x && root.__x.$data) || null;
      if (app) {
        if (typeof app.updateCart === 'function') app.updateCart.call(app, true);
        if (typeof app.openCart === 'function') app.openCart();
      }
    } catch (e) {}
    if (btn) {
      btn.textContent = 'Added ✓';
      btn.style.background = '#3B6D11';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 1800);
    }
  }

  /* v60.14 srAtcPrepare — kept for backward-compat with older HTML. */
  window.srAtcPrepare = window.srAtcPrepare || function () {
    var btn = document.getElementById('sr-atc-btn');
    var origLabel = btn ? btn.textContent : 'Add to cart';
    var defaultVid = btn ? parseInt(btn.getAttribute('data-sr-default-vid'), 10) : 0;

    // Compute slab payload (vid + qty) — uses the slab-aware atcPayload if available
    var p = (window.SrTheme && window.SrTheme.atcPayload)
      ? window.SrTheme.atcPayload(defaultVid)
      : { vid: defaultVid, qty: 1 };
    console.log('[SR atc prepare]', p);

    if (!p.vid || p.qty < 1) {
      console.warn('[SR atc prepare] invalid payload, blocking submit', p);
      if (btn) {
        btn.textContent = 'Pick variant/qty';
        btn.style.background = '#A32D2D';
        setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 2000);
      }
      return false;
    }

    // MTO MOQ check
    var mtoEl = document.querySelector('.sr-mto');
    if (mtoEl) {
      var moq = parseInt(mtoEl.getAttribute('data-sr-moq'), 10) || 0;
      if (moq > 0 && p.qty < moq) {
        if (btn) {
          btn.textContent = 'MOQ is ' + moq + ' units';
          btn.style.background = '#A32D2D';
          setTimeout(function () { btn.textContent = origLabel; btn.style.background = ''; }, 2200);
        }
        return false;
      }
    }

    // Update hidden quantity input (this is what Paper's submitCartForm reads)
    var hiddenQty = document.getElementById('sr-final-qty');
    if (hiddenQty) hiddenQty.value = String(p.qty);

    // Update variant id input (Paper's form has one)
    var idInp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInp && p.vid) idInp.value = String(p.vid);

    if (btn) {
      btn.textContent = 'Adding…';
      btn.disabled = true;
      // Re-enable after 2.5s in case Paper's submit handler doesn't finish
      setTimeout(function () {
        btn.disabled = false;
        if (btn.textContent === 'Adding…') btn.textContent = origLabel;
      }, 2500);
    }

    console.log('[SR atc prepare] submitting form, vid=' + p.vid + ' qty=' + p.qty);
    return true;  // Let the form submit → Paper's x-on:submit.prevent → submitCartForm
  };

  /* v60.8: Pack selector REWRITE — stepper = "how many packs you want",
     never modified by pack-tile clicks. ATC multiplies pack_qty × stepper
     at submit time. */
  function initPackSelector() {
    qsa('.sr-pack-grid').forEach(function (grid) {
      var btns = qsa('.sr-pb', grid);
      var priceEl = qs('#sr-price-main') || qs('[data-sr-price]');
      var mrpEl   = qs('#sr-price-mrp')  || qs('[data-sr-mrp]');
      var saveEl  = qs('#sr-price-save') || qs('[data-sr-save]');
      var atcEl   = qs('#sr-atc-btn')    || qs('.sr-atc');
      var variantInput = qs('input[name="id"]');
      var qtyInput = qs('#sr-qty-val') || qs('.sr-qty__input');
      var qtyWrap  = qs('.sr-qty-wrap');
      var defaultVariant = grid.getAttribute('data-default-variant') || '';

      var section = grid.closest('.sr-pack-section') || document;
      var customPanel = qs('.sr-custom-qty-panel', section);
      var customInput = qs('.sr-custom-qty-input', section);
      var customOutput = qs('.sr-custom-qty-output', section);

      function selectedTile() { return qs('.sr-pb.sr-sel', grid) || btns[0] || null; }
      function isCustom(tile) { return tile && tile.classList.contains('sr-pb--custom'); }

      function refreshAtcLabel() {
        if (!atcEl) return;
        /* v55.18: once PDP is in View Cart state, do not let qty/pack label
           refreshers rewrite the button back to Add to cart. Cart-mirror owns it. */
        if (atcEl.getAttribute('data-sr-pdp-incart') === '1') return;
        var tile = selectedTile();
        if (!tile) return;

        if (isCustom(tile)) {
          // Custom tile drives its own label via recomputeCustom below.
          var userQty = Math.max(0, parseInt(customInput && customInput.value, 10) || 0);
          if (!userQty) { atcEl.textContent = 'Enter quantity to continue'; return; }
          return;
        }

        // v63.02: stepperVal is in UNITS (not packs) since v61.28 made the
        // counter display the slab's pack qty. So total = unit-price × units.
        // data-price is the whole-pack price (₹2004 for ×300 pack); using it
        // here would multiply by 300 twice → ₹6,01,200 bug. data-unit-price
        // is the per-piece paise value (668 = ₹6.68/pc) — that's the right one.
        var unitPaise   = parseInt(tile.getAttribute('data-unit-price') || '0', 10);
        var perPackPaise = parseInt(tile.getAttribute('data-price') || '0', 10);
        var packQty     = parseInt(tile.getAttribute('data-pack-qty') || tile.getAttribute('data-slab-size') || '0', 10);
        var stepperVal  = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        // Prefer data-unit-price; fall back to perPack/packQty if missing.
        if (!unitPaise && perPackPaise && packQty) unitPaise = Math.round(perPackPaise / packQty);
        var grandTotalPaise = unitPaise ? (unitPaise * stepperVal) : (perPackPaise * (packQty ? Math.ceil(stepperVal / packQty) : 1));
               atcEl.innerHTML = '<span class="sr-atc-lab">Add to cart</span><span class="sr-atc-price">' + formatMoney(grandTotalPaise) + '</span>';
        atcEl.setAttribute('data-sr-add-html', atcEl.innerHTML);

      }

      btns.forEach(function (btn) {
        on(btn, 'click', function () {
          btns.forEach(function (b) { b.classList.remove('sr-sel'); });
          btn.classList.add('sr-sel');

          if (isCustom(btn)) {
            if (customPanel) customPanel.classList.add('sr-active');
            // Hide stepper while custom panel is open (issue #5: stepper 3-digit overflow)
            if (qtyWrap) qtyWrap.classList.add('sr-hide-stepper');
            if (customInput) setTimeout(function(){ customInput.focus(); }, 60);
            refreshAtcLabel();
            return;
          }

          // Non-custom: close custom panel + restore stepper
          if (customPanel) customPanel.classList.remove('sr-active');
          if (qtyWrap) qtyWrap.classList.remove('sr-hide-stepper');

          var perPackPaise = parseInt(btn.getAttribute('data-price') || '0', 10);
          var mrp = parseInt(btn.getAttribute('data-mrp') || '0', 10);
          var varId = btn.getAttribute('data-variant-id');
          var label = btn.getAttribute('data-label') || '';

          if (priceEl) priceEl.textContent = formatMoney(perPackPaise);
          if (mrpEl && mrp > perPackPaise) mrpEl.textContent = formatMoney(mrp);
          if (saveEl && mrp > perPackPaise) saveEl.textContent = 'Save ' + formatMoney(mrp - perPackPaise);

          // Sync variant id only — do NOT touch the stepper value
          if (variantInput && varId) variantInput.value = varId;

          qsa('.sr-br[data-pack]').forEach(function (row) {
            row.classList.toggle('sr-br--sel', row.getAttribute('data-pack') === label);
          });

          refreshAtcLabel();
        });
      });

      /* v61.x: RATE FOLLOWS QUANTITY (live). When the stepper crosses a tier
         boundary, auto-select the matching tier tile (first tier_max >= qty,
         else the largest = best rate) BEFORE refreshAtcLabel runs — so the
         highlighted pack, the variant that will be added, and the ATC total all
         track the quantity. tier-rate only; custom / variant-direct untouched. */
      function retierByQty() {
        if (atcEl && atcEl.getAttribute('data-sr-pdp-incart') === '1') return;
        if ((grid.getAttribute('data-tier-mode') || '') !== 'tier-rate') return;
        var cur = selectedTile();
        if (isCustom(cur)) return;
        var qv = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        var tl = qsa('.sr-pb:not(.sr-pb--custom)', grid).map(function (t) {
          return { el: t, max: parseInt(t.getAttribute('data-tier-max'), 10) || 0 };
        }).filter(function (x) { return x.max > 0; });
        tl.sort(function (a, b) { return a.max - b.max; });
        if (!tl.length) return;
        var m = null;
        for (var i = 0; i < tl.length; i++) { if (tl[i].max >= qv) { m = tl[i]; break; } }
        if (!m) m = tl[tl.length - 1];
        if (m.el === cur) return;               // already on the right tier
        tl.forEach(function (x) { x.el.classList.remove('sr-sel'); });
        m.el.classList.add('sr-sel');
        var varId = m.el.getAttribute('data-variant-id');
        if (variantInput && varId) variantInput.value = varId;   // add the right variant
      }

      // Stepper change → re-tier by qty first, then refresh ATC label (unit × qty)
      if (qtyInput) {
        on(qtyInput, 'input',  retierByQty);
        on(qtyInput, 'change', retierByQty);
        on(qtyInput, 'input',  refreshAtcLabel);
        on(qtyInput, 'change', refreshAtcLabel);
      }

      /* Custom panel — TIER-RATE pricing.
         User types N → find matching tier (variant whose tier_max >= N, else
         largest) → ceil N to multiple of smallest tier → display
         "Tier match × ceiled_qty = total" where total = variant.price × ceiled_qty. */
      function fmtRupeesCeil(rupees) { return '₹' + Math.ceil(rupees).toLocaleString('en-IN'); }

      // Snapshot tiers from the rendered tiles so the panel + ATC agree
      var tierTiles = qsa('.sr-pb:not(.sr-pb--custom)', grid);
      var tiers = tierTiles.map(function (t) {
        return {
          max:        parseInt(t.getAttribute('data-tier-max'), 10) || 0,
          unitPaise:  parseInt(t.getAttribute('data-unit-price'), 10) || 0,
          totalPaise: parseInt(t.getAttribute('data-price'), 10) || 0,
          vid:        parseInt(t.getAttribute('data-variant-id'), 10) || 0
        };
      }).filter(function (x) { return x.max > 0 && x.vid > 0; });
      tiers.sort(function (a, b) { return a.max - b.max; });

      var smallestTierMax = tiers.length ? tiers[0].max : 1;
      var isTierRate = grid.getAttribute('data-tier-mode') === 'tier-rate';

      function findTierFor(n) {
        if (!tiers.length) return null;
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].max >= n) return tiers[i];
        }
        return tiers[tiers.length - 1];  // beyond largest
      }

      if (customInput && isTierRate) {
        if (smallestTierMax > 1) customInput.setAttribute('step', String(smallestTierMax));
        customInput.setAttribute('min', String(smallestTierMax));

        function recomputeCustom(rawN) {
          if (atcEl && atcEl.getAttribute('data-sr-pdp-incart') === '1') return;
          if (!rawN) {
            if (customOutput) customOutput.innerHTML = '<span style="color:var(--sr-ink-30)">Enter quantity (multiple of ' + smallestTierMax + ') to see pricing</span>';
            if (atcEl) atcEl.textContent = 'Enter quantity to continue';
            return;
          }
          var ceiledN = Math.max(smallestTierMax, Math.ceil(rawN / smallestTierMax) * smallestTierMax);
          var t = findTierFor(rawN);
          if (!t) { if (atcEl) atcEl.textContent = 'No tier match'; return; }
          var unitRupees = t.unitPaise / 100;
          var totalRupees = unitRupees * ceiledN;
          var summary = ceiledN + ' units × ₹' + unitRupees.toFixed(2) + '/pc (tier max ' + t.max + ')';
          if (customOutput) {
            customOutput.innerHTML =
              '<div style="font-size:11px;color:var(--sr-ink-70);margin-bottom:4px">' + summary + '</div>' +
              '<div><strong>' + fmtRupeesCeil(totalRupees) + '</strong></div>';
          }
           if (atcEl) {
             atcEl.innerHTML = '<span class="sr-atc-lab">Add to cart</span><span class="sr-atc-price">' + fmtRupeesCeil(totalRupees) + '</span>';
             atcEl.setAttribute('data-sr-add-html', atcEl.innerHTML);
           }
        }

        on(customInput, 'input', function () {
          var raw = Math.max(0, parseInt(customInput.value, 10) || 0);
          recomputeCustom(raw);
        });
        on(customInput, 'blur', function () {
          var raw = Math.max(0, parseInt(customInput.value, 10) || 0);
          if (raw <= 0) return;
          var snapped = Math.max(smallestTierMax, Math.ceil(raw / smallestTierMax) * smallestTierMax);
          if (snapped !== raw) { customInput.value = snapped; recomputeCustom(snapped); }
        });
      }

            /* v63.54: Initial label + qty-poll. The Liquid pack-selector's
         inline script syncs #sr-qty-val to the selected pack's unit
         count (e.g. 100 for ×100 pack) AFTER this function runs, and
         it sets .value directly without dispatching input/change. So
         (a) defer initial refresh until after that sync has had a
         chance to run, and (b) lightly poll for stepper.value drift
         that didn't fire events. */
      refreshAtcLabel();
      setTimeout(refreshAtcLabel, 0);
      setTimeout(refreshAtcLabel, 100);
      setTimeout(refreshAtcLabel, 500);
      var lastSeenQty = qtyInput ? qtyInput.value : '';
      setInterval(function () {
        if (!qtyInput) return;
        if (qtyInput.value !== lastSeenQty) {
          lastSeenQty = qtyInput.value;
          refreshAtcLabel();
        }
      }, 350);


      /* v60.9 REWRITE — dead simple direct fetch, no Alpine app reliance.
         Three previous attempts hedged across Alpine + form + fetch paths
         which made bugs hard to isolate. This single path:
           - Reads selection state directly from DOM
           - POSTs to /cart/add.js with FormData
           - Surfaces real Shopify error messages on the button
           - Refreshes cart count + tries to open the drawer
         Exposed both as window.srAtcClick AND window.SrTheme.atc for
         backwards compat with the inline @click handler. */
      window.SrTheme = window.SrTheme || {};

      window.SrTheme.atcPayload = function (defaultVid) {
        var tile = selectedTile();
        var vid = defaultVid;
        if (tile && tile.getAttribute('data-variant-id')) vid = tile.getAttribute('data-variant-id');

        if (isCustom(tile)) {
          var userQty = Math.max(1, parseInt(customInput && customInput.value, 10) || 1);
          return { vid: parseInt(vid, 10) || 0, qty: userQty };
        }
        var packQty = tile ? Math.max(1, parseInt(tile.getAttribute('data-pack-qty'), 10) || 1) : 1;
        var stepperVal = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        return { vid: parseInt(vid, 10) || 0, qty: packQty * stepperVal };
      };

      window.SrTheme.atc = function (defaultVid) {
        var p = window.SrTheme.atcPayload(defaultVid);
        var btn = qs('#sr-atc-btn');
        var origLabel = btn ? btn.textContent : 'Add to Cart';
        console.log('[SR atc-slab] click', { vid: p.vid, qty: p.qty, defaultVid: defaultVid });
        if (!p.vid || p.qty < 1) {
          srPostAddError(new Error('Pick variant/qty'), btn, origLabel);
          return;
        }
        if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
        srCartAdd(p, btn, origLabel);  // includes MOQ check
      };

      // Alias for safety with simpler inline handlers
      window.srAtcClick = function () {
        var def = parseInt((qs('input[name="id"]') && qs('input[name="id"]').value) || defaultVariant || '0', 10);
        window.SrTheme.atc(def);
      };
    });
  }

  /* ── 6. PINCODE CHECKER ────────────────────────────────────
     v60.86: makes NO network request (no shipping-rates / API call,
     so no API errors). Validates the pincode and shows a concrete
     IST date-range estimate; a real serviceability source can plug
     in via window.SR_SERVICEABILITY without any theme change.

     Expects on the page:
       - .sr-pin__input  : text input
       - .sr-pin__btn    : check button
       - .sr-pin__result : result line (hidden until checked)
       - data-sr-cutoff="11" on the sr-pin wrapper (or body)
       - data-sr-ship-type on body ("stock" or "made_to_order")
  ────────────────────────────────────────────────────────── */
  function initPincodeChecker() {
    qsa('.sr-pin').forEach(function (wrap) {
      var input   = qs('.sr-pin__input', wrap);
      var btn     = qs('.sr-pin__btn', wrap);
      var result  = qs('.sr-pin__result', wrap);
      var loading = qs('.sr-pin__loading', wrap);
      if (!input || !btn || !result) return;

      var cutoff   = parseInt(wrap.getAttribute('data-sr-cutoff') || document.body.getAttribute('data-sr-cutoff') || '11', 10);
      var shipType = wrap.getAttribute('data-sr-ship-type') || document.body.getAttribute('data-sr-ship-type') || 'stock';

      /* v60.86 #2: NO network/API call (removes the shipping_rates.json
         API errors entirely). Pure client-side IST date math. A real
         serviceability source can plug in later via window.SR_SERVICEABILITY
         (return {minDays,maxDays} or {exact:'<label>'}) with no theme change;
         until then a concrete date-range fallback is shown. */
      function istNow(){ return new Date(Date.now() + 19800000); } // UTC+5:30, no DST
      function addBizDays(base, n){
        var d = new Date(base.getTime()), added = 0;
        while (added < n){ d.setUTCDate(d.getUTCDate() + 1); if (d.getUTCDay() !== 0) added++; } // skip Sundays
        return d;
      }
      function fmtDate(d){
        var dn=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var mn=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return dn[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + mn[d.getUTCMonth()];
      }
      function rangeLabel(minD, maxD){
        var base = istNow();
        return fmtDate(addBizDays(base, minD)) + ' – ' + fmtDate(addBizDays(base, maxD));
      }
      function serviceability(pin){
        try { if (typeof window.SR_SERVICEABILITY === 'function') return window.SR_SERVICEABILITY(pin) || null; }
        catch(e){}
        return null;
      }

      function doCheck() {
        var pin = (input.value || '').trim();
        if (!/^[0-9]{6}$/.test(pin)) {
          showResult('Please enter a valid 6-digit pincode.', true);
          return;
        }
        if (loading) loading.classList.add('sr-show');
        result.classList.remove('sr-show');
        setTimeout(function(){
          if (loading) loading.classList.remove('sr-show');
          var data = serviceability(pin);
          if (data && data.exact) {
            showResult('Delivery to ' + pin + ' · ' + data.exact, false); return;
          }
          if (data && data.minDays && data.maxDays) {
            showResult('Delivery to ' + pin + ' · Est. ' + rangeLabel(data.minDays, data.maxDays), false); return;
          }
          // No serviceability data → concrete date-range fallback
          if (shipType === 'made_to_order') {
            showResult('Made to order · Estimated delivery ' + rangeLabel(5, 7), false);
          } else {
            showResult('Estimated delivery ' + rangeLabel(7, 8) + ' · Free shipping', false);
          }
        }, 450);
      }

      function showResult(msg, isError) {
        result.textContent = msg;
        result.classList.toggle('sr-pin__result--error', isError);
        result.classList.add('sr-show');
      }

      on(btn, 'click', doCheck);
      on(input, 'keydown', function (e) { if (e.key === 'Enter') doCheck(); });
    });
  }

  /* ── 7. PRODUCT TITLE CLEANUP ──────────────────────────────
     Strips display prefixes like "Buy X for Packaging - "
     from product titles in cards. Does NOT modify Shopify data.
     Pattern matches "Buy ... for Packaging - " (case-insensitive).
  ────────────────────────────────────────────────────────── */
  function cleanProductTitles() {
    return; // v60.68: disabled — show raw Shopify titles verbatim
    var rx = /^Buy\s+(.+?)\s+for\s+Packaging\s*[\u002D\u2013]\s*/i;
    qsa('.sr-pcard__name, .sr-yml-card__name, .sr-pdp-name, [data-sr-title]').forEach(function (el) {
      var raw = el.getAttribute('data-raw-title') || el.textContent;
      el.setAttribute('data-raw-title', raw);
      el.textContent = raw.replace(rx, '').replace(/^Buy\s+/i, '');
    });
  }

  /* ── 8. SPEC ACCORDION ─────────────────────────────────────
     Toggle .sr-acc__body open/close on header click.
  ────────────────────────────────────────────────────────── */
  function initAccordions() {
    qsa('.sr-acc__hdr').forEach(function (hdr) {
      var body    = hdr.nextElementSibling;
      var chevron = qs('i, svg, .sr-acc-icon', hdr);
      // Open first accordion by default
      if (hdr.closest('.sr-acc:first-child') && body) {
        body.classList.add('sr-open');
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      }
      on(hdr, 'click', function () {
        var isOpen = body && body.classList.contains('sr-open');
        if (body) body.classList.toggle('sr-open', !isOpen);
        if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
      });
    });
  }

  /* ── 9. FILTER PILLS (collection page) ────────────────────
     Toggle active state. Navigates to filtered URL via
     data-filter-url or appends ?sort_by / tag params.
  ────────────────────────────────────────────────────────── */
  function initFilterPills() {
    qsa('.sr-fpill[data-filter]').forEach(function (pill) {
      on(pill, 'click', function (e) {
        var filterUrl = pill.getAttribute('data-filter-url');
        if (filterUrl) {
          window.location.href = filterUrl;
          return;
        }
        // Toggle active for UI-only pills (no URL change)
        pill.classList.toggle('sr-on');
      });
    });
  }

  /* ── 10. MONEY FORMATTER ───────────────────────────────────
     Formats paise integer to ₹X,XX,XXX format (Indian numbering).
  ────────────────────────────────────────────────────────── */
  function formatMoney(paise) {
    var rupees = paise / 100;
    return '₹' + rupees.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  /* ── 11. ANNOUNCEMENT COUPON COPY ─────────────────────────
     Click the pill to copy coupon code to clipboard.
  ────────────────────────────────────────────────────────── */
  function initAnnouncementCopy() {
    qsa('.sr-ann__pill[data-coupon]').forEach(function (pill) {
      on(pill, 'click', function () {
        var code = pill.getAttribute('data-coupon') || pill.textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var original = pill.textContent;
            pill.textContent = 'Copied!';
            setTimeout(function () { pill.textContent = original; }, 1600);
          });
        }
      });
    });
  }

  /* ── 12. SOLD-OUT BUTTON GUARD ─────────────────────────────
     Extra JS safety in case CSS specificity doesn't override.
  ────────────────────────────────────────────────────────── */
  function fixSoldOutButtons() {
    qsa('form[action="/cart/add"]').forEach(function (form) {
      var btn = qs('button[type="submit"]', form) || qs('.product-form__submit', form);
      if (!btn) return;
      var isAvail = form.getAttribute('data-available') !== 'false';
      // Check if the product is actually sold out via Shopify's own disabled state
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
        btn.style.cssText += ';background-color:#C8C4BC!important;color:#888!important;border-color:#C8C4BC!important;cursor:not-allowed!important;pointer-events:none!important;';
      }
    });
  }

  /* ── 13. WHATSAPP FAB SAFETY ───────────────────────────────
     Belt-and-suspenders: JS sets inline style after page load.
  ────────────────────────────────────────────────────────── */
  function fixWhatsappFab() {
    if (window.innerWidth >= 768) return;
    var selectors = [
      'a[href*="wa.me"]',
      'a[href*="whatsapp"]',
      '.wa-float',
      '.whatsapp-float',
      '.whatsapp-widget'
    ];
    /* v60.94: WhatsApp lives in the static bottom bar. Hide the
       app-injected floating FAB on mobile — but NEVER the bar's own
       WhatsApp link (it also matches a[href*="wa.me"]). The v60.89 bug
       was that this hid the bar's button "after a while" when JS ran. */
    selectors.forEach(function (sel) {
      qsa(sel).forEach(function (el) {
        if (el.closest('.sr-mbar')) return;            // never touch our bar
        var fab = el.closest('.whatsapp-widget,.whatsapp-float,.wa-float') || el;
        if (fab.closest && fab.closest('.sr-mbar')) return;
        fab.style.setProperty('display', 'none', 'important');
      });
    });
    /* Broad sweep for app FABs that don't match the simple selectors
       (iframes / divs with whatsapp in id/class), excluding our bar. */
    var extra = document.querySelectorAll(
      'iframe[src*="whatsapp" i],iframe[src*="wa.me" i],[id*="whatsapp" i],[class*="whatsapp" i],[id*="wa-widget" i],[class*="wa-widget" i]'
    );
    Array.prototype.forEach.call(extra, function (el) {
      if (el.closest('.sr-mbar')) return;
      el.style.setProperty('display', 'none', 'important');
    });
  }

  /* ── 14. STALE COUPON REMOVAL ──────────────────────────────
     Remove EIDPACK20 from cart drawer text nodes.
  ────────────────────────────────────────────────────────── */
  function removeStaleCopon() {
    var stale = 'EIDPACK20';
    document.querySelectorAll('*').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.includes(stale)) {
        el.textContent = el.textContent.replace(stale, '').replace(/Use code\s*:?\s*$/i, '').trim();
      }
    });
    // Also remove from attribute values (e.g. placeholder, value)
    qsa('[value*="EIDPACK20"], [placeholder*="EIDPACK20"], [data-code*="EIDPACK20"]').forEach(function (el) {
      ['value','placeholder','data-code'].forEach(function (attr) {
        if (el.getAttribute(attr) && el.getAttribute(attr).includes(stale)) {
          el.removeAttribute(attr);
        }
      });
    });
  }

  /* ── INIT ──────────────────────────────────────────────────
     Run everything after DOM is ready. Shopify's theme may
     load scripts deferred, so we use DOMContentLoaded +
     a MutationObserver for cart drawer injections.
  ────────────────────────────────────────────────────────── */

  /* ── 15. SR ATC WIRING ─────────────────────────────────────
     v60.8: REMOVED the duplicate click handler that called
     submitBtn.click(). It was firing in parallel with the
     Alpine `@click.prevent="addCartItem(...)"` handler in
     product__main.liquid, causing double-adds and reading the
     pre-slab-math stepper value (resulting in wrong qty added).
     The inline @click handler now uses SrTheme.atcPayload() to
     compute the correct (variant, qty) from the selected slab
     and stepper, and handles the "Adding…" feedback itself.
  ────────────────────────────────────────────────────────── */
  function initSrAtc() { /* no-op in v60.8 */ }

  /* ── 16. FILTER UNIT TOGGLES (Tier D scaffolding, v60.7) ──
     For collection-page filter groups labeled dimension/weight,
     render a pill row to switch between cm/mm/inch/m or g/kg.
     User preference persists in localStorage. Numeric portions of
     each chip label are converted on the fly — URL params remain
     in the canonical filter unit (set by Shopify Admin).
  ────────────────────────────────────────────────────────── */
  var SR_DIM_FACTORS = { mm: 1, cm: 10, in: 25.4, m: 1000 };          // mm per 1 unit
  var SR_WT_FACTORS  = { g: 1, kg: 1000 };                             // g per 1 unit
  function srConvert(value, fromUnit, toUnit, kind) {
    if (fromUnit === toUnit) return value;
    var factors = kind === 'weight' ? SR_WT_FACTORS : SR_DIM_FACTORS;
    var canonical = value * (factors[fromUnit] || 1);
    return canonical / (factors[toUnit] || 1);
  }
  function srFormatConverted(val, unit) {
    if (val >= 100) return Math.round(val) + ' ' + unit;
    if (val >= 10)  return val.toFixed(1) + ' ' + unit;
    return val.toFixed(2) + ' ' + unit;
  }
  function srStoredUnit(kind) {
    try { return localStorage.getItem('sr-unit-' + kind) || ''; } catch (e) { return ''; }
  }
  function srStoreUnit(kind, unit) {
    try { localStorage.setItem('sr-unit-' + kind, unit); } catch (e) {}
  }
  /* v60.36: Unit toggles + chip bucketing.
       - One global toggle per kind (dim, weight) at top of the sidebar.
       - Chips inside each dimension/weight group are bucketed by ceiling-
         to-nearest-0.5 (in canonical cm/kg). Duplicate buckets are merged
         and the resulting chip's href filters by ALL underlying values.
       - Product-tile dim overlays (.sr-pcard__dims) listen too: when the
         dim unit changes, every visible tile updates its displayed value. */
  function initFilterUnitToggles() {
    var rail = qs('.sr-collpage__filters');
    if (!rail) return;
    // v60.63: per-field default unit conversion must apply even when the
    // mm/cm/in pill UI is disabled. Only the toggle PILLS are gated by this
    // setting now — not the conversion itself.
    var showToggles = rail.getAttribute('data-sr-unit-toggles') !== 'false';

    var defaultDim = rail.getAttribute('data-sr-default-dim-unit') || 'cm';
    var defaultWt  = rail.getAttribute('data-sr-default-wt-unit')  || 'kg';
    var dimUnits = ['mm', 'cm', 'in', 'm']; // v60.62: 'm' added for per-field metre defaults
    var wtUnits  = ['g', 'kg'];

    // v60.67: was Math.ceil(v*2)/2 — ceiling to the nearest 0.5 of the
    // CANONICAL (cm) value distorted small widths after conversion
    // (5.08 cm → 5.5 → 2.17 in instead of 2 in). Buckets exist only to
    // merge truly-duplicate values, so round to 2 dp: dedupes identical
    // sizes without shifting them. Exact conversions now land clean
    // (5.08 cm → 2 in, 7.62 → 3, 6500 → 65 m).
    function snapHalfUp(v, fg) {
      /* v63.37: Volumetric/weight filter chips should display commercial
         0.5-kg buckets. Example: 2.333 -> 2.5. Dimension filters stay exact
         to avoid changing visible size values such as 5.08 cm -> 5.5 cm. */
      var kind = fg && fg.getAttribute && fg.getAttribute('data-sr-filter-kind');
      var label = '';
      try {
        var h = fg && fg.querySelector && fg.querySelector('.sr-fg__head');
        label = (h && h.textContent || '').toLowerCase();
      } catch(e) {}
      if (kind === 'weight' || label.indexOf('volumetric') > -1) {
        return Math.ceil(v * 2) / 2;
      }
      return Math.round(v * 100) / 100;
    }

    /* Bucket chips inside one .sr-fg group. Original chip values come from
       data-sr-canonical (the metafield value in the group's canonical unit).
       After bucketing, the group's chip list contains one chip per snapped
       value, with href filtering by every original value in that bucket. */
    function bucketGroup(fg) {
      var origChips = qsa('.sr-chip[data-sr-canonical]', fg);
      if (!origChips.length) return null;
      var container = origChips[0].parentNode;

      var paramName = null;
      var carry = {};                   // non-filter query params to preserve
      var carryFilter = {};             // OTHER filter params to preserve
      var firstHref = origChips[0].getAttribute('href');
      try {
        var u0 = new URL(firstHref, window.location.origin);
        u0.searchParams.forEach(function (v, k) {
          if (k.indexOf('filter.') !== 0) { carry[k] = v; return; }
          if (paramName === null) { paramName = k; return; }
          if (k !== paramName) {
            if (!carryFilter[k]) carryFilter[k] = [];
            carryFilter[k].push(v);
          }
        });
      } catch (e) {}

      var buckets = {};
      origChips.forEach(function (c) {
        var canonical = parseFloat(c.getAttribute('data-sr-canonical'));
        if (isNaN(canonical)) return;
        var snap = snapHalfUp(canonical, fg);
        if (!buckets[snap]) buckets[snap] = { snap: snap, values: [], active: false };
        try {
          var uu = new URL(c.getAttribute('href'), window.location.origin);
          uu.searchParams.getAll(paramName).forEach(function (v) { buckets[snap].values.push(v); });
        } catch (e) {}
        if (c.classList.contains('sr-chip--active')) buckets[snap].active = true;
      });

      var snaps = Object.keys(buckets).map(parseFloat).sort(function (a, b) { return a - b; });

      // Clear and re-build the chip container with bucket chips
      container.innerHTML = '';
      snaps.forEach(function (s) {
        var b = buckets[s];
        var url = new URL(window.location.pathname, window.location.origin);
        Object.keys(carry).forEach(function (k) { url.searchParams.append(k, carry[k]); });
        Object.keys(carryFilter).forEach(function (k) {
          carryFilter[k].forEach(function (v) { url.searchParams.append(k, v); });
        });
        if (paramName) b.values.forEach(function (v) { url.searchParams.append(paramName, v); });

        var a = document.createElement('a');
        a.className = 'sr-chip' + (b.active ? ' sr-chip--active' : '');
        a.setAttribute('aria-pressed', String(b.active));
        a.setAttribute('data-sr-canonical', String(s));
        a.href = url.pathname + url.search;
        var num = document.createElement('span');
        num.className = 'sr-chip__num';
        num.textContent = String(s);
        a.appendChild(num);
        container.appendChild(a);
      });

      return { fg: fg, snaps: snaps, canonicalUnit: fg.getAttribute('data-sr-filter-unit') };
    }

    /* Convert a canonical value to the display unit for chips/tiles. */
    function displayConvert(val, fromUnit, toUnit, kind) {
      var v = srConvert(val, fromUnit, toUnit, kind);
      return v;
    }

    /* For chips: short numeric display (no trailing .0). */
    function formatChip(v) {
      if (Math.abs(v - Math.round(v)) < 0.01) return String(Math.round(v));
      return v.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    }
    /* For tile overlay: keep up to 2 decimals (user requested). */
    function formatTile(v) {
      if (v === null || isNaN(v)) return '—';
      return v.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    }

    // Pre-populate data-sr-canonical on Liquid-rendered chips so bucketGroup
    // can find them. (Chip labels are rendered as a leading number followed
    // by an optional .sr-chip__count span; we extract the leading number.)
    qsa('.sr-fg', rail).forEach(function (fg) {
      var kind = fg.getAttribute('data-sr-filter-kind');
      if (kind !== 'dimension' && kind !== 'weight') return;
      qsa('.sr-chip', fg).forEach(function (chip) {
        if (chip.hasAttribute('data-sr-canonical')) return;
        var firstText = '';
        for (var i = 0; i < chip.childNodes.length; i++) {
          var n = chip.childNodes[i];
          if (n.nodeType === 3 && n.nodeValue.trim()) { firstText = n.nodeValue.trim(); break; }
        }
        if (!firstText) firstText = chip.textContent.trim();
        var match = firstText.match(/^([0-9]*\.?[0-9]+)/);
        if (match) chip.setAttribute('data-sr-canonical', match[1]);
      });
    });

    // === Collect dimension + weight groups, bucket their chips ===
    var dimGroups = [];
    var wtGroups = [];
    qsa('.sr-fg', rail).forEach(function (fg) {
      var kind = fg.getAttribute('data-sr-filter-kind');
      var canonical = fg.getAttribute('data-sr-filter-unit');
      if ((kind !== 'dimension' && kind !== 'weight') || !canonical) return;
      var b = bucketGroup(fg);
      if (!b) return;
      if (kind === 'dimension') dimGroups.push(b); else wtGroups.push(b);
    });

    // === Build the global toggles (only render kinds that have groups) ===
    var body = qs('.sr-collpage__filters-body', rail);
    if (!body) return;

    function makeToggle(kind, units, initialUnit, labelText) {
      var row = document.createElement('div');
      row.className = 'sr-collpage__filters-globaltoggles__row';
      var lbl = document.createElement('span');
      lbl.className = 'sr-collpage__filters-globaltoggles__label';
      lbl.textContent = labelText;
      row.appendChild(lbl);
      var box = document.createElement('div');
      box.className = 'sr-fg__unit';
      box.setAttribute('data-sr-kind', kind);
      units.forEach(function (u) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sr-fg__unit-btn' + (u === initialUnit ? ' sr-fg__unit-btn--on' : '');
        btn.setAttribute('data-unit', u);
        btn.textContent = u;
        on(btn, 'click', function () {
          qsa('.sr-fg__unit-btn', box).forEach(function (p) { p.classList.remove('sr-fg__unit-btn--on'); });
          btn.classList.add('sr-fg__unit-btn--on');
          // v60.65: TRANSIENT only. Do NOT persist (srStoreUnit removed) — a
          // stored unit was clobbering the merchant's per-field defaults on
          // the next page load, which is why editor (fresh) looked right but
          // preview (carrying old localStorage) was wrong. The per-field
          // config is now always the source of truth on load; this toggle is
          // just a momentary shopper view-switch.
          rerenderAll(kind, u);
        });
        box.appendChild(btn);
      });
      row.appendChild(box);
      return row;
    }

    /* Convert one filter group's chips to a unit. */
    function convGroup(g, toUnit, kind) {
      qsa('.sr-chip[data-sr-canonical]', g.fg).forEach(function (chip) {
        var v = parseFloat(chip.getAttribute('data-sr-canonical'));
        if (isNaN(v)) return;
        var conv = displayConvert(v, g.canonicalUnit, toUnit, kind);
        var num = chip.querySelector('.sr-chip__num');
        if (num) num.textContent = formatChip(conv);
      });
    }
    /* Set a tile dim-num's text to a converted value + inline unit. */
    function setTileNum(num, toUnit) {
      var cmVal = parseFloat(num.getAttribute('data-cm'));
      if (isNaN(cmVal)) return;
      var conv = displayConvert(cmVal, 'cm', toUnit, 'dimension');
      var inlineUnit = num.querySelector('.sr-pcard__dim-inline-unit');
      for (var i = num.childNodes.length - 1; i >= 0; i--) {
        if (num.childNodes[i].nodeType === 3) num.removeChild(num.childNodes[i]);
      }
      num.insertBefore(document.createTextNode(formatTile(conv)), num.firstChild);
      if (inlineUnit) inlineUnit.textContent = ' ' + toUnit;
    }

    /* Global toggle handler: force EVERY dimension group + tile to ONE unit
       (explicit shopper choice — overrides per-field defaults until reset). */
    function rerenderAll(kind, toUnit) {
      var groups = kind === 'dimension' ? dimGroups : wtGroups;
      groups.forEach(function (g) { convGroup(g, toUnit, kind); });
      if (kind === 'dimension') {
        qsa('.sr-pcard__dims-bar').forEach(function (bar) {
          qsa('.sr-pcard__dim-num', bar).forEach(function (num) { setTileNum(num, toUnit); });
          var trailingUnit = bar.querySelector(':scope > .sr-pcard__dim-unit');
          if (trailingUnit) trailingUnit.textContent = toUnit;
        });
      }
    }

    /* v60.62 default: render each group + each tile dim in ITS OWN unit
       (data-sr-filter-display-unit / data-sr-target-unit), so Length can
       show in m while Width shows in inches in the same collection. Only
       used when the shopper has NOT explicitly picked a global unit. */
    function renderPerField(kind) {
      var groups = kind === 'dimension' ? dimGroups : wtGroups;
      groups.forEach(function (g) {
        var du = g.fg.getAttribute('data-sr-filter-display-unit') || g.canonicalUnit;
        convGroup(g, du, kind);
      });
      if (kind === 'dimension') {
        qsa('.sr-pcard__dims-bar .sr-pcard__dim-num').forEach(function (num) {
          var tu = num.getAttribute('data-sr-target-unit') || num.getAttribute('data-native-unit') || 'cm';
          setTileNum(num, tu);
        });
      }
    }

    if (dimGroups.length || wtGroups.length) {
      var holder = document.createElement('div');
      holder.className = 'sr-collpage__filters-globaltoggles';

      // v60.65: per-field config is ALWAYS the source of truth on load.
      // No stored-unit override (that caused the editor-vs-preview mismatch).
      // The pill row is purely an optional, transient shopper view-switch,
      // shown only when the merchant enables it; it never changes the default.
      if (dimGroups.length) {
        if (showToggles) holder.appendChild(makeToggle('dimension', dimUnits, '', 'Dimensions'));
        renderPerField('dimension');
      }
      if (wtGroups.length) {
        if (showToggles) holder.appendChild(makeToggle('weight', wtUnits, '', 'Weight'));
        renderPerField('weight');
      }
      if (showToggles) body.insertBefore(holder, body.firstChild);
    }
  }

  /* v60.13: For non-slab products (incl. MTO), live-update the ATC
     button label as the qty stepper changes. Slab pack selector has
     its own refreshAtcLabel; this only runs when no pack grid is on
     the page. */
    /* v63.53: For non-slab products (incl. MTO + multi-variant), live-update
     the ATC button label as the qty stepper OR the variant changes. Slab
     pack selector has its own refreshAtcLabel; this only runs when no pack
     grid is on the page. The variant price is looked up against /products/
     <handle>.js (fetched once, cached) so changing size/colour updates the
     ATC price × qty multiplier correctly. */
  function initNonSlabAtcLabel() {
    var grid = qs('.sr-pack-grid');
    if (grid) return;  // slab handler does it
    var atcEl = qs('#sr-atc-btn');
    var qtyInput = qs('#sr-qty-val');
    if (!atcEl || !qtyInput) return;
    var basePaise = parseInt(atcEl.getAttribute('data-sr-base-price-paise'), 10) || 0;
    if (!basePaise) return;

    var productData = null;

    function getHandle() {
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        var m = canonical.href.match(/\/products\/([^\/?#]+)/);
        if (m) return m[1];
      }
      var pm = location.pathname.match(/\/products\/([^\/?#]+)/);
      return pm ? pm[1] : null;
    }
    function getCurrentVid() {
      try {
        var roots = document.querySelectorAll('[x-data]');
        for (var i = 0; i < roots.length; i++) {
          var r = roots[i];
          var d = (r && r._x_dataStack && r._x_dataStack[0]) || (r && r.__x && r.__x.$data) || null;
          if (d && d.current_variant_id) return parseInt(d.current_variant_id, 10);
        }
      } catch (e) {}
      try {
        var m = (location.search || '').match(/[?&]variant=(\d+)/);
        if (m) return parseInt(m[1], 10);
      } catch (e) {}
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (inp && inp.value) return parseInt(inp.value, 10);
      var dv = atcEl.getAttribute('data-sr-default-vid');
      return dv ? parseInt(dv, 10) : 0;
    }
    function syncBasePaiseFromVariant() {
      if (!productData || !productData.variants) return;
      var vid = getCurrentVid();
      if (!vid) return;
      for (var i = 0; i < productData.variants.length; i++) {
        if (productData.variants[i].id === vid) {
          // /products/<handle>.js prices are already in paise (integer cents).
          var p = parseInt(productData.variants[i].price, 10);
          if (p > 0) basePaise = p;
          return;
        }
      }
    }
    function refresh() {
      /* v55.18: if the PDP CTA is already View Cart, qty/variant refresh must
         not rewrite it back to Add to cart for one frame. */
      if (atcEl.getAttribute('data-sr-pdp-incart') === '1') return;
      syncBasePaiseFromVariant();
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      atcEl.innerHTML = '<span class="sr-atc-lab">Add to cart</span><span class="sr-atc-price">' + formatMoney(basePaise * qty) + '</span>';
      atcEl.setAttribute('data-sr-add-html', atcEl.innerHTML);
    }

    // Fetch product variants once so we can look up the current price by id.
    var handle = getHandle();
    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { productData = p; refresh(); } })
      .catch(function () {});
    }

    on(qtyInput, 'input', refresh);
    on(qtyInput, 'change', refresh);

    // Listen for variant changes from Paper's picker (it dispatches change
    // on the hidden form input[name="id"]).
    var vinp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (vinp) {
      on(vinp, 'change', refresh);
      on(vinp, 'input',  refresh);
    }
    // URL ?variant= changes (Paper pushState) — poll lightly.
    var lastSearch = location.search;
    setInterval(function () {
      if (location.search !== lastSearch) {
        lastSearch = location.search;
        refresh();
      }
    }, 600);

    refresh();
  }


  /* ── NOTIFY-ME (back-in-stock email capture) ──────────────────
     POSTs {email, product, handle, variant, ts} to the Google Apps
     Script web app URL set in Theme settings (notify_webhook_url).
     no-cors form-encoded POST so Apps Script accepts it without a
     CORS preflight; success shown optimistically. */
  function initNotify() {
    qsa('.sr-notify').forEach(function (form) {
      if (form.dataset.srInit) return;
      form.dataset.srInit = '1';
      var wrap   = form.closest('.sr-restock') || form.parentNode;
      var doneEl = wrap ? wrap.querySelector('.sr-notify__done') : null;
      var errEl  = wrap ? wrap.querySelector('.sr-notify__err') : null;
      var input  = form.querySelector('.sr-notify__input');
      var btn    = form.querySelector('.sr-notify__btn');
      var endpoint = (form.getAttribute('data-endpoint') || '').trim();

      on(form, 'submit', function (e) {
        e.preventDefault();
        var email = (input && input.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          if (input) { input.focus(); input.style.borderColor = '#A32D2D'; }
          return;
        }
        if (input) input.style.borderColor = '';

        if (!endpoint) {
          console.warn('[SR notify] no notify_webhook_url set in Theme settings');
          if (form) form.hidden = true;
          if (doneEl) doneEl.hidden = false;
          return;
        }

        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

        var payload = new URLSearchParams();
        payload.set('email', email);
        payload.set('product', form.getAttribute('data-product') || '');
        payload.set('handle', form.getAttribute('data-handle') || '');
        payload.set('variant', form.getAttribute('data-variant') || '');
        payload.set('ts', new Date().toISOString());
        payload.set('source', 'notify-me');

        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: payload.toString()
        }).then(function () {
          if (form) form.hidden = true;
          if (doneEl) doneEl.hidden = false;
        }).catch(function (err) {
          console.error('[SR notify] failed', err);
          if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
          if (errEl) errEl.hidden = false;
        });
      });
    });
  }

  function init() {
    // v60.64: isolate every init call. Previously these ran unguarded in
    // sequence, so a throw in any earlier function (e.g. on the collection
    // page) silently killed everything after it — which is exactly why the
    // dimension FILTER chips never converted (initFilterUnitToggles is 11th)
    // while the tile gold bar still did (that's Liquid-pre-rendered, not JS).
    var steps = [
      ['initParallax', initParallax],
      ['initHeroSlider', initHeroSlider],
      ['initCategoryTrays', initCategoryTrays],
      ['initMarqueeGlow', initMarqueeGlow],
      ['initPackSelector', initPackSelector],
      ['initNonSlabAtcLabel', initNonSlabAtcLabel],
      ['initPincodeChecker', initPincodeChecker],
      ['cleanProductTitles', cleanProductTitles],
      ['initAccordions', initAccordions],
      ['initFilterPills', initFilterPills],
      ['initFilterUnitToggles', initFilterUnitToggles],
      ['initAnnouncementCopy', initAnnouncementCopy],
      ['fixSoldOutButtons', fixSoldOutButtons],
      ['fixWhatsappFab', fixWhatsappFab],
      ['removeStaleCopon', removeStaleCopon],
      ['initSrAtc', initSrAtc],
      /* v61.04: srSyncMtoFlag init-step removed — was firing /cart.js on
         every page load and racing with card ATC fetches. The function
         is still defined and exposed on window.srSyncMtoFlag if needed
         post-add; #9 MTO line-item property is still stamped on PDP. */
      ['initCountUp', initCountUp],
      ['initNotify', initNotify]
    ];
    steps.forEach(function (s) {
      try { s[1](); }
      catch (e) { try { console.warn('SR init ' + s[0] + ':', e); } catch (_) {} }
    });
  }

  /* ── COUNT-UP ANIMATION ───────────────────────────────────── */
  function initCountUp() {
    var els = qsa('.sr-stat__val[data-countup]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup')) || parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
        var suffix = el.textContent.replace(/[0-9.,]/g, '').trim();
        var duration = 1200;
        var start = performance.now();
        function step(now) {
          var t = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - t, 3);
          var val = target * ease;
          el.textContent = (val >= 1000 ? Math.round(val).toLocaleString('en-IN') : val.toFixed(1)) + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        el.classList.add('sr-counted');
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) {
      el.setAttribute('data-countup', parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0);
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run lightweight fixes when cart drawer opens (Alpine.js mutation)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) {
        removeStaleCopon();
        fixSoldOutButtons();
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Expose public API for Liquid sections that call SrTheme.*
  window.SrTheme = {
    formatMoney: formatMoney,
    goToSlide: function () {},    // patched by initHeroSlider if needed
    refreshPackSelector: initPackSelector,
    checkPin: initPincodeChecker
  };

})();

/* v58: Removed dead "IIFE 16 — CARD QTY CONTROLS" block.
   It targeted .sr-pcard__atc-wrap markup which doesn't exist
   in any current section file. The v28 IIFE below is the only
   pill handler. */


/* v27 COMPREHENSIVE IIFE removed in v30 — its functionality is now
   handled by the v19_fixed base (initPackSelector, initFilterPills,
   initAccordions, fixSoldOutButtons) which works again after the
   comment-bug fix in v29, plus the v28 IIFE for ATC and Notify Me.
   This deletion eliminates the double-pill bug. */


/* ============================================================
   v28 IIFE — robust ATC + pill morph + late-render observer
   Appended to v27 base; existing v27 IIFE still runs.
   ============================================================ */
(function(){
  var D=document, W=window;
  function qs(s,c){return (c||D).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s))}

  // ---- Cart helpers (Alpine-first, fetch-fallback) ----
  function pApp(){
    try{
      var r=D.querySelector('[x-data*="app()"]')||D.documentElement;
      if(r&&r._x_dataStack&&r._x_dataStack[0])return r._x_dataStack[0];
      if(r&&r.__x&&r.__x.$data)return r.__x.$data;
    }catch(e){}
    return null;
  }
  function refreshCart(){
    var a=pApp();
    if(a){
      try{ if(typeof a.updateCart==='function') a.updateCart(true); }catch(e){}
      try{ if(typeof a.openCart==='function') a.openCart(); }catch(e){}
      try{ if(typeof a.toggleCart==='function') a.toggleCart(true); }catch(e){}
    }
    // Trigger Shopify cart change events for any other listeners
    try{
      D.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
      D.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    }catch(e){}
  }
  /* Quiet refresh — updates Paper's cart state + count badge but does
     NOT open the cart drawer. Used by the product-card +/- pill so
     adjusting qty from a tile doesn't pop the drawer every click. */
  function refreshCartQuiet(){
    var a=pApp();
    if(a){ try{ if(typeof a.updateCart==='function') a.updateCart(true); }catch(e){} }
    try{
      D.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
      D.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    }catch(e){}
  }
  function addToCart(vid, qty, silent, props){
    /* v63.26: accept an optional `props` map → forwarded as line-item
       properties. Lets tile/PDP/recommendations callers stamp MTO MOQ
       (_sr_moq) so the cart +/- can step by MOQ instead of 1. */
    qty = qty || 1;
    var hasProps = props && typeof props === 'object' && Object.keys(props).length > 0;
    var a = pApp();
    if(a && typeof a.addCartItem === 'function' && !hasProps){
      /* Paper's Alpine addCartItem path has no properties signature; use it
         only when no props are needed (regular non-MTO add). */
      try{ a.addCartItem(parseInt(vid,10), 0, qty, silent ? false : true); if(silent){ refreshCartQuiet(); } return Promise.resolve(true); }catch(e){}
    }
    var lineItem = { id: parseInt(vid,10), quantity: qty };
    if (hasProps) lineItem.properties = props;
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[lineItem]})
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(){ silent ? refreshCartQuiet() : refreshCart(); return true; })
      .catch(function(err){ console.warn('SR addToCart fetch failed', err); return false; });
  }
  /* v60.99 #9: reconcile the cart-level MTO flag. Sets cart attribute
     _mto_present='yes' when ANY line carries the "Made to order"
     property, else clears it — so the Shiprocket Checkout COD rule is
     accurate even after MTO items are removed. Idempotent; no loop. */
  function srSyncMtoFlag(){
    fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var hasMto = (cart.items||[]).some(function(it){
          var p = it.properties || {};
          return !!(p['Made to order'] || p['_mto'] || p['_mto_present']);
        });
        var cur = (cart.attributes && cart.attributes._mto_present) || '';
        var want = hasMto ? 'yes' : '';
        if(cur === want){ return; }              // already correct → no write, no loop
        var at = {}; at._mto_present = want;
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',body:JSON.stringify({attributes:at})}).catch(function(){});
      }).catch(function(){});
  }
  window.srSyncMtoFlag = srSyncMtoFlag;
  function updateCartLine(vid, qty, silent){
    var u={}; u[String(vid)] = qty;
    return fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({updates:u})
    }).then(function(r){ return r.json(); })
      .then(function(){ silent ? refreshCartQuiet() : refreshCart(); return true; })
      .catch(function(){ return false; });
  }

  // ---- 1. ROBUST PRODUCT-CARD ATC (button-click intercept, not form submit) ----
  function initCardATC(){
    qsa('.sr-pcard__atc-form').forEach(function(form){
      if(form.dataset.sr28) return;
      form.dataset.sr28 = '1';
      var btn = form.querySelector('button');
      var idIn = form.querySelector('input[name="id"]');
      if(!btn || !idIn) return;
      var vid = idIn.value;
      var wrap = form.parentNode;

      // v60.99 #9: is this card a Made-to-order product? (its card carries
      // the .sr-flair--mto badge). If so, every add stamps the line-item
      // property so Shiprocket Checkout can drop COD.
      var _cardEl = form.closest('.sr-pcard,.sr-pg__card,article');
      var cardMto = !!(_cardEl && _cardEl.querySelector('.sr-flair--mto'));

      // #4: MTO products carry data-sr-moq on the form. The card "add"
      // adds MOQ units (not 1) and the pill starts at MOQ. Step stays 1.
      var moq = parseInt(form.getAttribute('data-sr-moq'), 10) || 1;

      // Build pill (hidden initially). Inter tabular numerals; min-width
      // sized so 3-digit qtys (e.g. 100) don't get clipped.
      var pill = D.createElement('div');
      pill.className = 'sr-pcard__pill';
      pill.hidden = true; // v63.01: also set the [hidden] attr so CSS [hidden]{display:none} can win against any !important display rule
      pill.style.cssText = 'display:none;align-items:center;background:#0E0E0C;border-radius:100px;height:32px;overflow:hidden;align-self:flex-start;width:max-content;max-width:100%;flex:0 0 auto;box-sizing:border-box;transition:transform .18s cubic-bezier(.34,1.56,.64,1)';
      pill.innerHTML =
        '<button type="button" aria-label="Decrease" data-d="-1" style="width:30px;height:32px;background:transparent;border:none;color:#F5F1E8;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif">\u2212</button>' +
        '<span class="sr-pcard__pill-val" style="min-width:34px;padding:0 4px;text-align:center;font-size:12.5px;font-weight:600;color:#F5F1E8;font-family:Inter,system-ui,sans-serif;font-variant-numeric:tabular-nums lining-nums">' + moq + '</span>' +
        '<button type="button" aria-label="Increase" data-d="1" style="width:30px;height:32px;background:transparent;border:none;color:#F5F1E8;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif">+</button>';
      wrap.appendChild(pill);
      var valEl = pill.querySelector('.sr-pcard__pill-val');

      var qty = 0;
      var busy = false;
      // v60.59: stale-cart guard. A local add/±  fires cart:updated, which
      // makes syncPillsWithCart re-fetch /cart.js — but Paper's add is async,
      // so that fetch can read the line as 0 and momentarily flip the pill
      // back to "+" (the reported pill→+→pill flicker). While a local op is
      // in flight (and briefly after), external syncs are ignored — local
      // state is authoritative; later syncs reconcile once the cart settles.
      var lockUntil = 0;
      function lockLocal(){ lockUntil = Date.now() + 1800; }

      // v63.01: toggle the [hidden] attr alongside inline display so any
      // CSS rule with `display:* !important` on these elements can't keep
      // both visible at once. The [hidden] attr is the truth signal —
      // sr-fixes.css `[hidden]{display:none!important}` wins everywhere.
      function showForm(){ form.hidden=false; pill.hidden=true;  form.style.display=''; pill.style.display='none'; }
      function showPill(){ form.hidden=true;  pill.hidden=false; form.style.display='none'; pill.style.display='inline-flex'; }
      function bump(el){
        el.style.transform='scale(1.12)';
        setTimeout(function(){ el.style.transform='scale(1)'; }, 180);
      }
      function setQtyVisual(n){ qty = n; valEl.textContent = String(n); }

      // Expose internal state for external sync (v58)
      form._srSetQtyExternal = function(n){
        // Ignore external sync while a local op is in flight / just settled —
        // prevents a stale /cart.js read from clobbering the fresh pill state.
        if(busy || Date.now() < lockUntil) return;
        qty = n;
        if(n === 0){ showForm(); }
        else { valEl.textContent = String(n); showPill(); }
      };
      form._srVid = String(vid);

      // PRIMARY: intercept button click. Stop Alpine submit, do our own ATC.
      // First add = MOQ units (1 for normal products). Silent = no drawer pop.
      btn.addEventListener('click', function(ev){
        if(busy) return;
        ev.preventDefault();
        ev.stopPropagation();
        busy = true;
        lockLocal();
        btn.classList.add('sr-pcard__add--loading');
        /* v63.26: stamp _sr_moq + Made-to-order on the line item so the cart
           drawer +/- can step by MOQ for MTO products added from a tile. */
        var _props = null;
        if (cardMto) {
          _props = { '_sr_moq': String(moq), 'Made to order': 'Yes' };
        }
        Promise.resolve(addToCart(vid, moq, true, _props)).then(function(){
          busy = false;
          lockLocal();
          btn.classList.remove('sr-pcard__add--loading');
          setQtyVisual(moq);
          showPill();
          bump(pill);
        });
      }, true); // capture phase: fires before Alpine's @submit handler

      // Also intercept form submit as last-resort safety
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        if(!busy){ btn.click(); }
      }, true);

      // v61.26 — Pill +/- handlers step by SLAB (was 1).
      // For a Pack-of-100 variant, click + adds 100, click - removes 100.
      // Below 1 slab → line removed entirely. No loopholes anywhere.
      qsa('button', pill).forEach(function(b){
        b.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if(busy) return;
          busy = true;
          lockLocal();
          var d = parseInt(b.getAttribute('data-d'), 10);
          var step = moq || 1;            // step by MOQ multiple
          var newQty = qty + (d * step);  // ±slab, not ±1
          if(newQty < moq){
            updateCartLine(vid, 0, true).then(function(){
              busy = false;
              lockLocal();
              setQtyVisual(0);
              showForm();
            });
          } else if (d > 0) {
            /* v63.26: pass MTO props on every increment so Shopify treats it
               as the same line (matching properties) instead of opening a
               new one — and the line keeps _sr_moq for cart stepping. */
            var _props = cardMto ? { '_sr_moq': String(moq), 'Made to order': 'Yes' } : null;
            addToCart(vid, step, true, _props).then(function(){    // add `step` units
              busy = false;
              lockLocal();
              setQtyVisual(newQty);
              bump(pill);
            });
          } else {
            updateCartLine(vid, newQty, true).then(function(){
              busy = false;
              lockLocal();
              setQtyVisual(newQty);
              bump(pill);
            });
          }
        });
      });
    });
  }

  // ---- 2. NOTIFY ME (more robust matcher) ----
  function initNotifyMe28(){
    // Match any sold-out / notify combination
    qsa('.template-product main *').forEach(function(el){
      if(el.dataset.srN28) return;
      var t = (el.textContent || '').trim();
      var ariaDisabled = el.getAttribute('aria-disabled') === 'true';
      var styleDisabled = (el.style && (el.style.cursor === 'not-allowed' || el.style.pointerEvents === 'none'));
      var classDisabled = el.className && el.className.toString && /disabled|sold-out|unavailable/i.test(el.className.toString());
      var looksLikeSoldOut = (t.length < 80) && /sold\s*out/i.test(t) && (ariaDisabled || styleDisabled || classDisabled || /notify/i.test(t));
      if(!looksLikeSoldOut) return;
      // Don't replace if a notify form already exists nearby
      if(el.querySelector && el.querySelector('.sr-nfy')) return;
      if(el.closest && el.closest('.sr-nfy')) return;
      el.dataset.srN28 = '1';

      var box = D.createElement('div');
      box.className = 'sr-nfy sr-nfy--auto';
      box.innerHTML =
        '<div class="sr-nfy__h">Sold out right now</div>' +
        '<div class="sr-nfy__sub">Drop your details — we\'ll ping you the moment it\'s back.</div>' +
        '<div class="sr-nfy__row">' +
          '<input type="email" class="sr-nfy__in" placeholder="Email" autocomplete="email">' +
          '<input type="tel" class="sr-nfy__in" placeholder="Phone (optional)" maxlength="10">' +
          '<button type="button" class="sr-nfy__btn">Notify me</button>' +
        '</div>' +
        '<div class="sr-nfy__ok" style="display:none">Got it. We\'ll email you when it\'s restocked.</div>';
      // Replace the disabled element
      try{ el.parentNode.replaceChild(box, el); }catch(e){ return; }
    });

    // Wire submit on every notify form (covers static + dynamic)
    qsa('.sr-nfy').forEach(function(pop){
      if(pop.dataset.srI28) return;
      pop.dataset.srI28 = '1';
      var btn = qs('.sr-nfy__btn', pop);
      var ok = qs('.sr-nfy__ok', pop);
      var ins = qsa('.sr-nfy__in', pop);
      if(!btn) return;
      btn.addEventListener('click', function(){
        var email = (qs('input[type="email"]', pop) || {}).value || '';
        var phone = (qs('input[type="tel"]', pop) || {}).value || '';
        if(!email.trim() && !phone.trim()){ ins[0] && ins[0].focus(); return; }
        if(W.SR_NOTIFY_WEBHOOK){
          try{
            fetch(W.SR_NOTIFY_WEBHOOK, {
              method:'POST', mode:'no-cors',
              headers:{'Content-Type':'text/plain;charset=utf-8'},
              body: JSON.stringify({
                type:'restock_alert', email:email, phone:phone,
                product:D.title, url:location.href, timestamp:new Date().toISOString()
              })
            });
          }catch(e){}
        }
        if(ok) ok.style.display = 'block';
        ins.forEach(function(i){ i.disabled = true; });
        btn.disabled = true;
        btn.textContent = 'Subscribed';
        btn.style.background = '#2E5A3A';
        btn.style.color = '#F5F1E8';
      });
    });
  }

  // ---- 3. KILL "DEFAULT TITLE" remnants on PDP variant labels ----
  function killDefaultTitle(){
    qsa('.template-product *').forEach(function(el){
      if(el.children && el.children.length === 0){
        var t = (el.textContent || '').trim();
        if(t === 'Default Title' || t === 'Default'){
          var parent = el.closest('[class*="variant"], [class*="option"], .sr-pack-section');
          if(parent){ parent.style.display = 'none'; }
          else { el.style.display = 'none'; }
        }
      }
    });
  }

  // ---- 4. Run all + mutation observer for late Alpine renders ----
  var pending = false;
  function runAll(){
    pending = false;
    /* v63.41: card ATC is handled by the final global SR card controller below.
       Keep notify/default-title fixes, but do not initialise the legacy v28
       card handler because it creates a second pill and steps MTO by MOQ. */
    /* try{ initCardATC(); }catch(e){ console.warn('SR v28 ATC:', e); } */
    try{ initNotifyMe28(); }catch(e){ console.warn('SR v28 notify:', e); }
    try{ killDefaultTitle(); }catch(e){ console.warn('SR v28 default:', e); }
  }
  function scheduleRun(){
    if(pending) return;
    pending = true;
    setTimeout(runAll, 60);
  }

  if(D.readyState === 'loading'){
    D.addEventListener('DOMContentLoaded', runAll);
  } else {
    setTimeout(runAll, 100);
  }
  D.addEventListener('shopify:section:load', runAll);
  D.addEventListener('shopify:section:reorder', runAll);

  // Mutation observer — catches Alpine-rendered products that arrive after init
  if(W.MutationObserver){
    var mo = new MutationObserver(function(mutations){
      for(var i=0; i<mutations.length; i++){
        var added = mutations[i].addedNodes;
        for(var j=0; j<added.length; j++){
          var n = added[j];
          if(n.nodeType !== 1) continue;
          if(n.classList && (n.classList.contains('sr-pcard__atc-form') || n.classList.contains('sr-pcard'))){
            scheduleRun(); return;
          }
          if(n.querySelector && (n.querySelector('.sr-pcard__atc-form') || n.querySelector('.sr-pcard'))){
            scheduleRun(); return;
          }
        }
      }
    });
    mo.observe(D.body || D.documentElement, {childList: true, subtree: true});
  }
})();

/* ============================================================
   v29 IIFE — title cleaning + extra ATC safety
   Append-only over v28. Runs after v27 + v28 IIFEs.
   ============================================================ */
(function(){
  var D=document, W=window;
  function qsa(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s))}

  // Strip "Buy X for Packaging - " prefix and "Buy X - " patterns from any title text node.
  // Also strip trailing "(Pack of N)" so titles read as "Brown Tape — 2in x 100m"
  function cleanTitle(text){
    return text; // v60.68: disabled — return title unchanged
    var t = text;
    // Strip leading "Buy " up to " for Packaging - " or " - "
    t = t.replace(/^\s*Buy\s+(.+?)(?:\s+for\s+Packaging)?\s*[-–—]\s*/i, '$1 — ');
    // If still has "Buy " prefix without separator
    t = t.replace(/^\s*Buy\s+/i, '');
    // Move "(Pack of N)" to a tag-style suffix
    t = t.replace(/\s*\(Pack\s+of\s+(\d+)\)\s*$/i, ' · Pack of $1');
    return t.trim();
  }

  // Apply to product card names, cart line items, search results, recommendations
  function cleanProductTitles(){
    return; // v60.68: disabled — show raw Shopify titles verbatim
    var selectors = [
      '.sr-pcard__name',                           // SR product card
      '[class*="product-card"] [class*="title"]',  // Paper collection product cards
      '[class*="product-card"] h3',
      '[class*="product-card"] h4',
      '[class*="product-card"] a > p',
      'body.product h1',                           // PDP heading
      '[x-text*="product_title"]',                 // Cart line items (Alpine-rendered)
    ];
    selectors.forEach(function(sel){
      qsa(sel).forEach(function(el){
        if(el.dataset.srCleaned) return;
        // Don't touch elements with Alpine x-text — they re-render dynamically
        if(el.hasAttribute('x-text')) return;
        var orig = el.textContent;
        var cleaned = cleanTitle(orig);
        if(cleaned && cleaned !== orig.trim()){
          el.textContent = cleaned;
        }
        el.dataset.srCleaned = '1';
      });
    });

    // Alpine-rendered cart titles: re-format after each render via MutationObserver below.
  }

  // Also clean breadcrumb / page titles on PDP
  function cleanPDPTitle(){
    return; // v60.68: disabled — show raw Shopify PDP title verbatim
    if(!document.body.classList.contains('product')) return;
    var h1 = D.querySelector('main h1');
    if(h1 && !h1.dataset.srCleaned){
      var t = cleanTitle(h1.textContent);
      if(t) h1.textContent = t;
      h1.dataset.srCleaned = '1';
    }
    // Document title in <title>
    if(D.title && !D.title._srCleaned){
      var dt = cleanTitle(D.title);
      if(dt && dt !== D.title) D.title = dt;
      D.title._srCleaned = true;
    }
  }

  // Cart line items render via Alpine x-text — observe their containers and patch on update
  function watchCartLines(){
    var cartRoot = D.querySelector('[class*="cart"]') || D.body;
    if(!cartRoot) return;
    var ttObserver = new MutationObserver(function(){
      qsa('[x-text*="product_title"]').forEach(function(el){
        var t = el.textContent;
        if(!t) return;
        var c = cleanTitle(t);
        if(c && c !== t.trim()){
          el.textContent = c;
        }
      });
    });
    ttObserver.observe(cartRoot, {subtree:true, characterData:true, childList:true});
  }

  // Extra-strong + button defense (in case v28 IIFE didn't catch a card)
  function lockProductCards(){
    qsa('.sr-pcard__atc-form').forEach(function(form){
      // Force form to never submit
      form.setAttribute('onsubmit', 'return false;');
      form.addEventListener('submit', function(e){ e.preventDefault(); e.stopPropagation(); return false; }, true);
      // Force button to be type="button"
      var btn = form.querySelector('button');
      if(btn && btn.getAttribute('type') !== 'button'){
        btn.setAttribute('type', 'button');
      }
    });
  }

  function go29(){
    try{ lockProductCards(); }catch(e){}
    try{ cleanProductTitles(); }catch(e){}
    try{ cleanPDPTitle(); }catch(e){}
  }

  if(D.readyState === 'loading'){
    D.addEventListener('DOMContentLoaded', go29);
  } else {
    setTimeout(go29, 120);
  }
  D.addEventListener('shopify:section:load', go29);

  // Watch cart lines indefinitely
  if(D.readyState === 'loading'){
    D.addEventListener('DOMContentLoaded', watchCartLines);
  } else {
    setTimeout(watchCartLines, 200);
  }
})();

/* ============================================================
   v36: PRODUCT GRID HORIZONTAL CAROUSEL
   - Hover chevrons, drag-to-scroll, snap, edge fade, gold progress thumb
   - Mobile: 2-row swipe (CSS-only, native scroll)
   ============================================================ */
(function () {
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function initRails() {
    $$('[data-sr-pg]').forEach(function (sec) {
      if (sec.dataset.srPgInit) return;
      sec.dataset.srPgInit = '1';

      var rail = sec.querySelector('[data-sr-pg-rail]');
      var prev = sec.querySelector('[data-sr-pg-prev]');
      var next = sec.querySelector('[data-sr-pg-next]');
      var thumb = sec.querySelector('[data-sr-pg-thumb]');
      if (!rail) return;

      function getCardStep() {
        var card = rail.querySelector('.sr-pg__card');
        if (!card) return 200;
        var styles = getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || '12') || 12;
        return card.getBoundingClientRect().width + gap;
      }

      function updateState() {
        var max = rail.scrollWidth - rail.clientWidth;
        var current = rail.scrollLeft;
        if (prev) prev.toggleAttribute('disabled', current <= 4);
        if (next) next.toggleAttribute('disabled', current >= max - 4);
        if (thumb && rail.scrollWidth > 0) {
          var thumbW = Math.max(8, (rail.clientWidth / rail.scrollWidth) * 100);
          var thumbL = max > 0 ? (current / max) * (100 - thumbW) : 0;
          thumb.style.width = thumbW + '%';
          thumb.style.left = thumbL + '%';
        }
      }

      function step(dir) {
        var visibleCards = Math.max(1, Math.floor(rail.clientWidth / getCardStep()));
        rail.scrollBy({ left: dir * visibleCards * getCardStep(), behavior: 'smooth' });
      }

      if (prev) on(prev, 'click', function () { step(-1); });
      if (next) on(next, 'click', function () { step(1); });

      on(rail, 'scroll', updateState, { passive: true });
      on(window, 'resize', updateState);

      /* Drag-to-scroll DISABLED in v40 — was causing dead clicks on product
         cards if user wiggled the mouse even slightly during a click. Native
         horizontal scroll (mouse wheel + trackpad) and chevron buttons cover
         it. Mobile uses native finger swipe. */

      /* Initial pass */
      requestAnimationFrame(updateState);
      setTimeout(updateState, 250);
    });
  }

  /* ============================================================
     v36: COLLECTION FILTER SIDEBAR — mobile collapse + exact dim
     ============================================================ */
  function initCollectionFilters() {
    /* Mobile filters toggle */
    $$('.sr-collpage__filters-toggle').forEach(function (btn) {
      if (btn.dataset.srInit) return;
      btn.dataset.srInit = '1';
      on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    /* Unit toggle (cm / in / mm) — converts displayed values on the chips.
       Storage is in cm (canonical). in/mm are display conversions only. */
    $$('.sr-fg__unit').forEach(function (group) {
      if (group.dataset.srInit) return;
      group.dataset.srInit = '1';
      var btns = $$('.sr-fg__unit-btn', group);
      btns.forEach(function (b) {
        on(b, 'click', function () {
          btns.forEach(function (x) { x.classList.remove('sr-fg__unit-btn--on'); });
          b.classList.add('sr-fg__unit-btn--on');
          var unit = b.dataset.unit;
          var sidebar = group.closest('.sr-collpage__filters');
          if (!sidebar) return;
          $$('.sr-chip[data-dim-cm]', sidebar).forEach(function (chip) {
            var cm = parseFloat(chip.dataset.dimCm);
            if (isNaN(cm)) return;
            var num = chip.querySelector('.sr-chip__num');
            if (!num) return;
            if (unit === 'cm') num.textContent = cm;
            else if (unit === 'in') num.textContent = (cm / 2.54).toFixed(1).replace(/\.0$/, '');
            else if (unit === 'mm') num.textContent = Math.round(cm * 10);
          });
        });
      });
    });

    /* Exact dimension input — parses "25x20x15" or "25×20×15" then redirects.
       Always interpreted as CM (canonical unit). */
    $$('[data-sr-exact-dim]').forEach(function (input) {
      if (input.dataset.srInit) return;
      input.dataset.srInit = '1';
      on(input, 'keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var v = (input.value || '').toLowerCase().replace(/\s+/g, '').replace(/[×x]/g, ',');
        var parts = v.split(',').map(function (p) { return parseInt(p, 10); }).filter(function (n) { return !isNaN(n) && n > 0; });
        if (parts.length < 1) return;
        var sidebar = input.closest('.sr-collpage__filters');
        var collUrl = (sidebar && sidebar.dataset.collectionUrl) || '/collections/all';
        var qs = [];
        if (parts[0]) qs.push('filter.p.m.custom.length_cm=' + parts[0]);
        if (parts[1]) qs.push('filter.p.m.custom.width_cm=' + parts[1]);
        if (parts[2]) qs.push('filter.p.m.custom.height_cm=' + parts[2]);
        window.location.href = collUrl + (qs.length ? '?' + qs.join('&') : '');
      });
    });
  }

  function boot() {
    initRails();
    initCollectionFilters();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Re-init in Theme Editor on section load */
  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   v52: Nav cursor-tracked radial gradient
   Sets --mx and --my CSS vars on each .type__nav link based on
   mouse position so the gold glassy pill renders centered at the
   cursor. Pure CSS handles the rest (radial-gradient using vars).
   ============================================================ */
(function () {
  function bindNavCursor() {
    var links = document.querySelectorAll('a.type__nav, .type__nav');
    links.forEach(function (link) {
      if (link.dataset.srNavCursor === '1') return;
      link.dataset.srNavCursor = '1';

      // Skip icon-only links (cart, account, search) — don't need the radial
      var href = (link.getAttribute('href') || '').toLowerCase();
      var aria = (link.getAttribute('aria-label') || '').toLowerCase();
      if (
        href.indexOf('cart') !== -1 ||
        href.indexOf('account') !== -1 ||
        href.indexOf('login') !== -1 ||
        aria.indexOf('search') !== -1 ||
        aria.indexOf('cart') !== -1 ||
        aria.indexOf('account') !== -1
      ) return;

      link.addEventListener('mousemove', function (e) {
        var rect = link.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        link.style.setProperty('--mx', x + 'px');
        link.style.setProperty('--my', y + 'px');
      });

      link.addEventListener('mouseleave', function () {
        link.style.removeProperty('--mx');
        link.style.removeProperty('--my');
      });
    });
  }

  function srNavCursorBoot() {
    bindNavCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', srNavCursorBoot);
  } else {
    srNavCursorBoot();
  }

  /* Re-bind if Shopify Theme Editor reloads the header section */
  document.addEventListener('shopify:section:load', srNavCursorBoot);

  /* Also re-bind on Alpine.js page transitions (Paper uses Alpine) */
  if (window.MutationObserver) {
    var headerObs = new MutationObserver(function () { bindNavCursor(); });
    document.addEventListener('DOMContentLoaded', function () {
      var hdr = document.querySelector('header, [class*="theme__header"], [id*="theme_header"]');
      if (hdr) headerObs.observe(hdr, { childList: true, subtree: true });
    });
  }
})();

/* v58: Removed v55 bindQuickAdd block.
   It targeted [data-sr-quick-add] markup which doesn't exist
   in any current section. The v28 IIFE above is the only
   pill handler. */

/* ============================================================
   v56: Sticky-header scroll shadow toggle
   Adds class `sr-header--scrolled` to the header group wrapper
   when scroll position > 4px. Pure visual flair — drop shadow
   appears as content scrolls underneath, vanishes at top.
   ============================================================ */
(function () {
  function srStickyHeaderShadow() {
    var hdr = document.querySelector('.shopify-section-group-header-group, [class*="shopify-section-group-header-group"]');
    if (!hdr) return;

    var scrolled = false;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      var nowScrolled = y > 4;
      if (nowScrolled !== scrolled) {
        scrolled = nowScrolled;
        if (scrolled) hdr.classList.add('sr-header--scrolled');
        else hdr.classList.remove('sr-header--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); /* initial check */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', srStickyHeaderShadow);
  } else {
    srStickyHeaderShadow();
  }
})();

/* ============================================================
   v58: Cart-drawer sync for product card pills
   When item is removed/added externally (cart drawer, /cart page),
   re-fetch /cart.js and update each card's pill state to match.
   Uses the v28 IIFE's exposed _srSetQtyExternal hook on each form.
   ============================================================ */
(function () {
  var D = document;
  function qsa(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }

  function applyPills(cart){
    if (!cart) return;
    var inCart = {};
    if (cart.items) {
      cart.items.forEach(function (item) {
        inCart[String(item.variant_id)] = item.quantity;
      });
    }
    qsa('.sr-pcard__atc-form').forEach(function (form) {
      if (typeof form._srSetQtyExternal !== 'function' || !form._srVid) return;
      var qty = inCart[form._srVid] || 0;
      form._srSetQtyExternal(qty);
    });
    qsa('[x-text="cart.item_count"], [data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }
  function syncPillsWithCart(eOrCart) {
    /* v63.27 #2: short-circuit when the cart payload comes via event detail
       or as a direct arg — no extra /cart.js fetch, instant repaint. */
    if (eOrCart && eOrCart.detail && eOrCart.detail.cart) { applyPills(eOrCart.detail.cart); return; }
    if (eOrCart && eOrCart.items && typeof eOrCart.item_count !== 'undefined') { applyPills(eOrCart); return; }
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyPills)
      .catch(function () { });
  }

  D.addEventListener('click', function (e) {
    if (e.target.closest('.sr-pcard__atc-form, .sr-pcard__pill')) return;
    setTimeout(syncPillsWithCart, 400);
  });

  D.addEventListener('visibilitychange', function () {
    if (!D.hidden) syncPillsWithCart();
  });

  D.addEventListener('cart:refresh', syncPillsWithCart);
  D.addEventListener('cart:updated', syncPillsWithCart);

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', function () { setTimeout(syncPillsWithCart, 600); });
  } else {
    setTimeout(syncPillsWithCart, 600);
  }
})();

/* ============================================================
   v59: Premium cart toast — animated slide-in with product image,
   item count, and View cart / Checkout CTAs. Replaces Paper's
   default cart-notification (which is hidden via CSS).
   Detects every add path (PDP, SR cards, +/- pills, Paper forms)
   by snapshotting /cart.js and diffing on cart:updated events
   plus add-button clicks.
   ============================================================ */
(function () {
  var D = document;
  function qs(s, c) { return (c || D).querySelector(s); }

  var lastCart = null;
  var lastShownAt = 0;
  var inflight = false;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function findChangedItem(prev, next) {
    if (!next || !next.items) return null;
    if (!prev) return null;
    for (var i = 0; i < next.items.length; i++) {
      var it = next.items[i];
      var match = null;
      for (var j = 0; j < prev.items.length; j++) {
        if (prev.items[j].variant_id === it.variant_id) { match = prev.items[j]; break; }
      }
      if (!match) return it;
      if (it.quantity > match.quantity) return it;
    }
    return null;
  }

  /* v55.25: helper for direct toast rendering from an already-returned cart.
     This avoids the old extra /cart.js fetch after a successful + click, which
     made the toast feel late. */
  function lineHandle(it) {
    if (!it) return '';
    if (it.handle) return String(it.handle);
    var u = it.url || '';
    var m = String(u).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function showFromResolvedCart(cart, variantId, handle, force) {
    if (!cart || !cart.items) return;
    if (window.srSuppressCartToastUntil && Date.now() < window.srSuppressCartToastUntil) {
      lastCart = cart;
      return;
    }

    var line = null;
    if (variantId) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) { line = cart.items[i]; break; }
      }
    }
    if (!line && handle) {
      for (var j = 0; j < cart.items.length; j++) {
        if (lineHandle(cart.items[j]) === String(handle)) { line = cart.items[j]; break; }
      }
    }
    if (!line && !force) line = findChangedItem(lastCart, cart);
    if (!line) { lastCart = cart; return; }

    lastCart = cart;
    var now = Date.now();
    if (now - lastShownAt < 450) return;
    lastShownAt = now;
    showToast(line, cart.item_count);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function cleanTitle(raw) {
    return String(raw == null ? '' : raw); // v60.68: disabled — return title unchanged
    return String(raw || '')
      .replace(/^\s*Buy\s+(.+?)(?:\s+for\s+Packaging)?\s*[-–—]\s*/i, '$1 — ')
      .replace(/^\s*Buy\s+/i, '')
      .replace(/\s*\(Pack\s+of\s+(\d+)\)\s*$/i, ' · Pack of $1')
      .trim();
  }

  function showToast(line, count) {
    if (!line) return;

    // Remove any existing toast first so a rapid sequence stacks cleanly
    var existing = qs('.sr-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var imgUrl = line.image || (line.featured_image && line.featured_image.url) || '';
    if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
    var imgSized = imgUrl ? imgUrl.replace(/(\.(?:png|jpg|jpeg|webp))(\?|$)/i, '_120x$1$2') : '';

    var titleClean = cleanTitle(line.product_title || line.title || '');
    var variantTitle = line.variant_title;
    if (variantTitle === 'Default Title' || variantTitle === 'Default') variantTitle = '';

    var t = D.createElement('div');
    t.className = 'sr-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML =
      '<button type="button" class="sr-toast__close" aria-label="Dismiss">' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
          '<path d="M2 2L10 10M10 2L2 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>' +
      '<div class="sr-toast__head">' +
        '<span class="sr-toast__check" aria-hidden="true">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
            '<path d="M3 7.5L6 10.5L11.5 4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
        '<span class="sr-toast__label">Added to cart</span>' +
        '<span class="sr-toast__count">' + count + (count === 1 ? ' item' : ' items') + '</span>' +
      '</div>' +
      '<div class="sr-toast__body">' +
        (imgSized
          ? '<div class="sr-toast__img"><img src="' + escapeHtml(imgSized) + '" alt="" loading="lazy"></div>'
          : '<div class="sr-toast__img sr-toast__img--blank" aria-hidden="true"></div>') +
        '<div class="sr-toast__meta">' +
          '<div class="sr-toast__title">' + escapeHtml(titleClean) + '</div>' +
          (variantTitle ? '<div class="sr-toast__variant">' + escapeHtml(variantTitle) + '</div>' : '') +
          (line.quantity ? '<div class="sr-toast__qty">Qty ' + line.quantity + '</div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="sr-toast__actions">' +
        '<a class="sr-toast__cta sr-toast__cta--ghost" role="link" tabindex="0" style="cursor:pointer">View cart</a>' +
        /* v61.27: route through Shiprocket Headless via hash. cart__main.liquid
           detects #shiprocket-checkout on load and auto-clicks the injected
           .shiprocket-headless button. View Cart stays at /cart (no hash). */
        '<a href="/cart#shiprocket-checkout" class="sr-toast__cta sr-toast__cta--primary">Checkout' +
          '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">' +
            '<path d="M2 5.5H9M9 5.5L6 2.5M9 5.5L6 8.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</a>' +
      '</div>' +
      '<div class="sr-toast__progress"><span></span></div>';

    D.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('sr-toast--in'); });

    var dismissTimer = setTimeout(dismiss, 1400);
    function dismiss() {
      clearTimeout(dismissTimer);
      t.classList.remove('sr-toast--in');
      t.classList.add('sr-toast--out');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
    }

    var closeBtn = t.querySelector('.sr-toast__close');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    var viewCartLink = t.querySelector('.sr-toast__cta--ghost');
    if (viewCartLink) viewCartLink.addEventListener('click', function () {
      if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) { dismiss(); return; }
      window.location.href = '/cart';
    });

    // Pause progress + auto-dismiss on hover
    var progressBar = t.querySelector('.sr-toast__progress span');
    t.addEventListener('mouseenter', function () {
      clearTimeout(dismissTimer);
      if (progressBar) progressBar.style.animationPlayState = 'paused';
    });
    t.addEventListener('mouseleave', function () {
      if (progressBar) progressBar.style.animationPlayState = 'running';
      dismissTimer = setTimeout(dismiss, 1400);
    });
  }

  function checkAndToast() {
    if (inflight) return;
    inflight = true;
    fetchCart().then(function (next) {
      inflight = false;
      if (!next) return;
      if (window.srSuppressCartToastUntil && Date.now() < window.srSuppressCartToastUntil) {
        lastCart = next;
        return;
      }
      var changed = findChangedItem(lastCart, next);
      lastCart = next;
      if (!changed) return;
      var now = Date.now();
      if (now - lastShownAt < 800) return; // throttle rapid double-fires
      lastShownAt = now;
      showToast(changed, next.item_count);
    });
  }

  // Public API for explicit triggers (e.g. from custom buttons)
  window.srCartToast = {
    check: checkAndToast,
    /* Use this when caller already has the cart payload. No extra /cart.js. */
    showFromCart: function (cart, variantId, handle) {
      showFromResolvedCart(cart, variantId, handle, true);
    },
    showFor: function (variantId) {
      fetchCart().then(function (cart) {
        showFromResolvedCart(cart, variantId, '', true);
      });
    }
  };

  /* v60.17: Initial snapshot. If user clicks ATC before this resolves
     (race on slow networks), default lastCart to empty so the first
     add can still be diffed. */
  lastCart = { items: [], item_count: 0 };
  fetchCart().then(function (c) { if (c) lastCart = c; });

  // Catch any add-to-cart click globally
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest(
      'button[name="add"],' +
      ' .sr-pcard__add,' +
      ' .sr-atc,' +
      ' .sr-pcard__pill button[data-d="1"],' +
      ' [data-add-to-cart]'
    );
    if (!addBtn) return;
    setTimeout(checkAndToast, 120);
    setTimeout(checkAndToast, 650); // fallback for slow networks
  }, true);

  D.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) { showFromResolvedCart(e.detail.cart, '', '', false); return; }
    setTimeout(checkAndToast, 80);
  });
  D.addEventListener('cart:refresh', function (e) {
    if (e && e.detail && e.detail.cart) { showFromResolvedCart(e.detail.cart, '', '', false); return; }
    setTimeout(checkAndToast, 80);
  });
})();

/* ============================================================
   v61.26 — global slab parser. Reads pack size from any
   line-item-like object (cart line or variant). Returns the
   integer slab (e.g. "Pack of 100" → 100). Falls back to 1
   when nothing matches. Used by cart page + drawer +/- handlers
   to step in slab multiples — no loopholes.
   ============================================================ */
window.srParseSlab = function(item){
  if(!item) return 1;
  function lastInt(s){
    if(!s) return 0;
    var parts = String(s).trim().split(/[\s\-]+/);
    var n = parseInt(parts[parts.length - 1], 10);
    return (n && n > 1) ? n : 0;
  }
  // Try variant_title, variant_options[0], product_title, title, options_with_values
  var candidates = [
    item.variant_title,
    item.variant_options && item.variant_options[0],
    item.product_title,
    item.title,
    item.options_with_values && item.options_with_values[0] && item.options_with_values[0].value
  ];
  var best = 0;
  for(var i = 0; i < candidates.length; i++){
    var n = lastInt(candidates[i]);
    if(n > best) best = n;
  }
  // Also try product metafield-injected attribute if rendered: data-sr-moq from any
  // adjacent .sr-pcard__atc-form (rare in cart context but safe to check).
  return best > 0 ? best : 1;
};

/* v63.03 — tier-aware cart quantity change.
   - For Pack-of-N (single-variant) products: step qty by slab, remove
     below one slab. Same behaviour as before.
   - For tier-rate products (variant titles like "0-100", "101-200",
     "201-300"): minus drops to the TOP of the next-lower tier and
     SWAPS the variant so the per-pack rate updates. Plus mirrors that
     by jumping to the next-higher tier.
   Used by Alpine handlers in cart__main.liquid + template__cart-item.liquid
   via window.srSlabChange(item, dir). Returns truthy synchronously so
   the Alpine button-loading guard still triggers; the actual cart write
   happens asynchronously and fires cart:refresh on completion. */

// Parse a variant title like "201-300" or "1-100" → {min, max}; else null.
window.srParseTierRange = function(s){
  if(!s) return null;
  var m = String(s).trim().match(/^\s*(\d+)\s*[-–—]\s*(\d+)\s*$/);
  if(!m) return null;
  var lo = parseInt(m[1], 10), hi = parseInt(m[2], 10);
  if(isNaN(lo) || isNaN(hi) || hi < lo) return null;
  return { min: lo, max: hi };
};

function _srCartChange(key, qty){
  return fetch('/cart/change.js', {
    method:'POST', credentials:'same-origin',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); });
}
function _srCartAdd(vid, qty, props){
  var body = { id: vid, quantity: qty };
  if (props && typeof props === 'object' && Object.keys(props).length) body.properties = props;
  return fetch('/cart/add.js', {
    method:'POST', credentials:'same-origin',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify(body)
  }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); });
}
function _srCartRefresh(){
  // v63.05: walk every Alpine root and call updateCart on any that
  // expose it. Then also dispatch the standard cart:* events. If the
  // open cart drawer is visible AND hasn't picked up the change within
  // 700ms, hard-reload — the cart is the worst place to leave the
  // shopper guessing about whether the qty actually updated.
  var beforeCount = -1;
  try{
    var badge = document.querySelector('[x-text="cart.item_count"], [data-cart-count]');
    if(badge && badge.textContent) beforeCount = parseInt(badge.textContent, 10);
  }catch(e){}
  function pokeAlpine(){
    try{
      var roots = document.querySelectorAll('[x-data]');
      for(var i = 0; i < roots.length; i++){
        var r = roots[i];
        var d = null;
        if(r && r._x_dataStack && r._x_dataStack[0]) d = r._x_dataStack[0];
        else if(r && r.__x && r.__x.$data)            d = r.__x.$data;
        if(d && typeof d.updateCart === 'function'){ try{ d.updateCart(true); }catch(e){} }
      }
    }catch(e){}
  }
  pokeAlpine();
  try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); } catch(e){}
  try { document.dispatchEvent(new CustomEvent('cart:updated',  { bubbles:true })); } catch(e){}
  // Re-poke after the cart AJAX settles (covers the case where the
  // first poke happened before our /cart/change.js had updated the
  // session cart).
  setTimeout(pokeAlpine, 250);
  setTimeout(function(){
    var drawerOpen = false;
    try{
      var drawer = document.querySelector('[x-show*="cart_drawer"], [x-show*="cart_alert"], .cart-drawer, [data-cart-drawer]');
      drawerOpen = !!(drawer && drawer.offsetParent !== null);
    }catch(e){}
    if(!drawerOpen) return;
    // Compare cart count to before; if unchanged AND we just wrote a
    // change, hard-reload as the safety net.
    try{
      var b = document.querySelector('[x-text="cart.item_count"], [data-cart-count]');
      var nowCount = b && b.textContent ? parseInt(b.textContent, 10) : NaN;
      if(!isNaN(nowCount) && !isNaN(beforeCount) && nowCount === beforeCount){
        location.reload();
      }
    }catch(e){}
  }, 800);
}

// Resolve the product handle from a cart line.
function _srItemHandle(item){
  if(!item) return '';
  if(item.handle) return item.handle;
  if(item.url){
    var m = String(item.url).match(/\/products\/([^/?#]+)/);
    if(m) return m[1];
  }
  return '';
}

// Cache /products/<handle>.js so repeated +/- clicks don't re-fetch.
var _srProductCache = {};
function _srFetchProduct(handle){
  if(!handle) return Promise.resolve(null);
  if(_srProductCache[handle]) return Promise.resolve(_srProductCache[handle]);
  return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials:'same-origin' })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if(p) _srProductCache[handle] = p; return p; })
    .catch(function(){ return null; });
}

// Pick the variant whose tier range contains targetQty (highest-coverage tier
// wins when overlaps exist). Returns null if no tier-range variants exist.
function _srPickTierVariant(product, targetQty){
  if(!product || !product.variants || !targetQty) return null;
  var best = null;
  product.variants.forEach(function(v){
    var r = window.srParseTierRange(v.title) || window.srParseTierRange(v.option1);
    if(!r) return;
    if(targetQty >= r.min && targetQty <= r.max){
      if(!best || (r.max - r.min) < (best.range.max - best.range.min)){
        best = { variant: v, range: r };
      }
    }
  });
  return best;
}

window.srSlabChange = function(item, dir){
  if(!item) return false;
  dir = (dir < 0) ? -1 : 1;

  // Is this a tier-rate item? Look at its variant_title / option1.
  var range = window.srParseTierRange(item.variant_title)
            || (item.variant_options && window.srParseTierRange(item.variant_options[0]))
            || (item.options_with_values && item.options_with_values[0] && window.srParseTierRange(item.options_with_values[0].value));

  if(!range) return _srSimpleSlabStep(item, dir);

  var handle = _srItemHandle(item);
  if(!handle) return _srSimpleSlabStep(item, dir);

  /* v63.28 — tier variants step by the MINIMUM TIER MAX (e.g. tiers
     "0-150" / "151-300" / "301-500" → step = 150). Each click moves
     the qty to the next multiple of that step, and the variant is
     swapped to the one whose tier range covers the new qty. NEVER ±1
     for tier products. */
  _srFetchProduct(handle).then(function(product){
    var minTierMax = 0;
    if (product && product.variants) {
      product.variants.forEach(function(v){
        var r = window.srParseTierRange(v.title) || window.srParseTierRange(v.option1);
        if (r && r.max > 0 && (minTierMax === 0 || r.max < minTierMax)) {
          minTierMax = r.max;
        }
      });
    }
    if (!minTierMax) {
      // No tier variants found — fall back to ±1 on the current line.
      _srSimpleSlabStep(item, dir);
      return;
    }

    var curQty = parseInt(item.quantity, 10) || 0;
    var newQty = curQty + (dir * minTierMax);
    if (newQty < 1) {
      /* Step took us to or below 0 — remove the line. */
      _srCartChange(item.key, 0)
        .then(function(){
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function(r){ return r.ok ? r.json() : null; });
        })
        .then(function(cart){
          if (cart && typeof window.srSyncAlpineFromCart === 'function') { try { window.srSyncAlpineFromCart(cart); } catch(e){} }
          if (typeof window.srBroadcastCart === 'function') { try { window.srBroadcastCart(cart); } catch(e){} }
          else { _srCartRefresh(); }
        })
        .catch(function(){ _srCartRefresh(); });
      return;
    }

    var pick = _srPickTierVariant(product, newQty);
    var newVid = pick ? pick.variant.id : (item.variant_id || item.id);
    var carryProps = {};
    try {
      if (item.properties) {
        for (var pk in item.properties) {
          if (Object.prototype.hasOwnProperty.call(item.properties, pk) && item.properties[pk] !== null && item.properties[pk] !== '') {
            carryProps[pk] = String(item.properties[pk]);
          }
        }
      }
    } catch(e){}

    if (newVid === item.variant_id || newVid === item.id) {
      /* Same variant — qty-change only. */
      _srCartChange(item.key, newQty)
        .then(function(cart){
          if (cart && typeof window.srSyncAlpineFromCart === 'function') { try { window.srSyncAlpineFromCart(cart); } catch(e){} }
          if (typeof window.srBroadcastCart === 'function') { try { window.srBroadcastCart(cart); } catch(e){} }
          else { _srCartRefresh(); }
        })
        .catch(function(){ _srCartRefresh(); });
      return;
    }

    /* Variant swap: remove old, add new with carried properties. */
    _srCartChange(item.key, 0)
      .then(function(){ return _srCartAdd(newVid, newQty, carryProps); })
      .then(function(){
        return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function(r){ return r.ok ? r.json() : null; });
      })
      .then(function(cart){
        if (cart && typeof window.srSyncAlpineFromCart === 'function') { try { window.srSyncAlpineFromCart(cart); } catch(e){} }
        if (typeof window.srBroadcastCart === 'function') { try { window.srBroadcastCart(cart); } catch(e){} }
        else { _srCartRefresh(); }
      })
      .catch(function(){ _srCartRefresh(); });
  });

  return true;  // signal Alpine handler to mark button loading
};

function _srSimpleSlabStep(item, dir){
  /* v63.23 — single source of truth for non-tier cart stepping.
     Rules (clarified by user):
       • Tier-rate variants ("1-100", "101-200" …)  → tier swap (handled
         in the srSlabChange tier path above, not here).
       • MTO with MOQ                                → ±1; drop to 0 when
         going below MOQ; coming up from 0 snaps to MOQ.
       • Everything else (incl. "Pack of N" single-variant items)
                                                     → ±1.

     Pack size is NOT the step size. srParseSlab returns 100 for
     "Pack of 100" but that's just the pack size; the cart qty is the
     number of packs, so stepping by 1 is what the shopper actually
     wants. The previous slab-as-step caused 1 → 101 jumps on +. */
  var moq = 0;
  try {
    if (item.properties && item.properties._sr_moq) moq = parseInt(item.properties._sr_moq, 10) || 0;
    if (!moq && item.properties && item.properties._moq) moq = parseInt(item.properties._moq, 10) || 0;
  } catch(e){}
  var curQty = parseInt(item.quantity, 10) || 0;
  var step = 1;
  var newQty = curQty + (dir * step);
  if (newQty < 0) newQty = 0;
  if (moq) {
    if (dir < 0 && newQty > 0 && newQty < moq) newQty = 0;            // drop to 0 below MOQ
    else if (dir > 0 && curQty === 0)         newQty = moq;            // 0 → MOQ snap on +
  }
  if (typeof changeCartItemQuantity === 'function') {
    try { changeCartItemQuantity(item.key, newQty, false, false); } catch(e){}
  } else {
    _srCartChange(item.key, newQty).then(_srCartRefresh).catch(function(){});
  }
  /* Mutate item.quantity inline so Alpine re-renders the input without
     waiting for the cart AJAX round-trip. The cart refresh below resyncs. */
  try { item.quantity = newQty; } catch(e){}
  return newQty;
}

/* v63.23 — public stepper. Returns the new quantity (or undefined when
   the tier-swap path handles things asynchronously). Used by Alpine
   click handlers in cart__main.liquid and template__cart-item.liquid. */
window.srCartStep = function(item, dir){
  if (!item) return undefined;
  dir = (dir < 0) ? -1 : 1;
  var range = window.srParseTierRange(item.variant_title)
            || (item.variant_options && window.srParseTierRange(item.variant_options[0]))
            || (item.options_with_values && item.options_with_values[0] && window.srParseTierRange(item.options_with_values[0].value));
  if (range) {
    /* tier-rate variant: existing async swap logic. Returns truthy but
       the actual qty/variant change happens in a fetch → don't try to
       mutate item.quantity here. */
    window.srSlabChange(item, dir);
    return undefined;
  }
  return _srSimpleSlabStep(item, dir);
};

/* ============================================================
   v63.27 #2 — Global cart-line stepper for cart drawer + cart page.
   Optimistic local mutation BEFORE the network responds, so the
   cart count badge, totals, line price, and progress bar all
   update instantly. The /cart/change.js response is then used for
   the hard-sync — no second /cart.js fetch (Paper's updateCart()
   roundtrip removed), so a click → repaint is one network hop
   that the eye never sees because the local state already matches.

   Step rules:
     • MTO line (has _sr_moq / _moq property): step = MOQ
     • Everything else: step = 1
     • Going below MOQ on '-': drop to 0 (remove)
     • '+' from 0: snap to MOQ
   ============================================================ */
(function(){
  var D = document;
  function findCartApp(){
    var roots = D.querySelectorAll('[x-data]');
    for (var i = 0; i < roots.length; i++){
      var r = roots[i];
      var d = (r && r._x_dataStack && r._x_dataStack[0]) || (r && r.__x && r.__x.$data) || null;
      if (d && typeof d.updateCart === 'function') return d;
    }
    return null;
  }
  function broadcastCart(cartData){
    var detail = cartData ? { cart: cartData } : undefined;
    try { D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail })); } catch(e){}
    try { D.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail })); } catch(e){}
  }
  /* v55.28 — keep cart line order stable across quantity changes.
     Shopify may return tier/slab swaps as remove+add, which visually pushes
     the line around. Keep the user's existing visible order and insert any
     replacement line back where the old product line was. */
  function _srLineHandle(it){
    var u = it && it.url ? String(it.url) : '';
    var m = u.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function _srLineIdentity(it){
    if (!it) return '';
    return String(it.product_id || '') + '|' + _srLineHandle(it) + '|' + String(it.sku || '');
  }
  function _srCloneCartItems(items){
    return (items || []).map(function(x){
      var o = {}; for (var k in x) { if (Object.prototype.hasOwnProperty.call(x,k)) o[k] = x[k]; } return o;
    });
  }
  function _srOrderCartItems(items, app){
    items = items || [];
    try {
      var prevItems = window.__srCartOrderItems || ((app && app.cart && app.cart.items) ? app.cart.items : []);
      var order = window.__srCartOrderKeys || (prevItems || []).map(function(it){ return it && it.key; }).filter(Boolean);
      var incomingKeys = items.map(function(it){ return it && it.key; }).filter(Boolean);
      order = order.filter(function(k){ return incomingKeys.indexOf(k) !== -1; });
      items.forEach(function(it){
        if (!it || !it.key || order.indexOf(it.key) !== -1) return;
        var ident = _srLineIdentity(it);
        var oldIndex = -1;
        if (ident) {
          for (var i = 0; i < (prevItems || []).length; i++) {
            var old = prevItems[i];
            if (old && old.key && incomingKeys.indexOf(old.key) === -1 && _srLineIdentity(old) === ident) {
              oldIndex = (window.__srCartOrderKeys || []).indexOf(old.key);
              if (oldIndex < 0) oldIndex = i;
              break;
            }
          }
        }
        if (oldIndex >= 0) order.splice(Math.min(oldIndex, order.length), 0, it.key);
        else order.push(it.key);
      });
      var rank = {}; order.forEach(function(k, i){ rank[k] = i; });
      var sorted = items.slice().sort(function(a,b){
        var ra = Object.prototype.hasOwnProperty.call(rank, a.key) ? rank[a.key] : 999999;
        var rb = Object.prototype.hasOwnProperty.call(rank, b.key) ? rank[b.key] : 999999;
        return ra - rb;
      });
      window.__srCartOrderKeys = sorted.map(function(it){ return it && it.key; }).filter(Boolean);
      window.__srCartOrderItems = _srCloneCartItems(sorted);
      return sorted;
    } catch(e) { return items; }
  }

  /* Hard-sync Alpine cart state directly from a /cart/change.js or /cart.js
     response. Mirrors what Paper's updateCart() does, but without doing its
     own /cart.js GET — saves one roundtrip per click. */
  function syncAlpineFromCart(cart){
    var app = findCartApp();
    if (!app || !app.cart || !cart) return;
    try {
      var orderedItems = _srOrderCartItems(cart.items || [], app);
      app.cart.items = _srCloneCartItems(orderedItems);
      app.cart.item_count = cart.item_count;
      app.cart.total_price = cart.total_price;
      app.cart.original_total_price = cart.original_total_price;
      app.cart.total_discount = cart.total_discount;
      if ('cart_level_discount_applications' in cart) {
        app.cart.cart_level_discount_applications = cart.cart_level_discount_applications;
      }
      if (typeof app.progress_bar_threshold !== 'undefined') {
        var rate = ((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? parseFloat(window.Shopify.currency.rate) : 1) || 1;
        var threshold = app.progress_bar_threshold * rate;
        var calcTotal = (app.cart.progress_bar_calculation === 'total') ? app.cart.total_price : app.cart.original_total_price;
        if (threshold > 0) {
          app.cart.progress_bar_remaining = threshold - calcTotal;
          app.cart.progress_bar_percent = (calcTotal / threshold * 100) + '%';
        }
      }
    } catch(e){}
  }
  window.srBroadcastCart = broadcastCart;
  window.srSyncAlpineFromCart = syncAlpineFromCart;

  window.srStepCartLine = function(item, dir){
    window.srSuppressCartToastUntil = Date.now() + 1800;
    if (!item || !item.key) return;
    dir = (dir < 0) ? -1 : 1;

    /* v63.28 — tier-range variant ("0-150", "151-300" …): swap to the
       neighbouring tier variant. srSlabChange handles the async swap. */
    var range = null;
    try {
      if (window.srParseTierRange) {
        range = window.srParseTierRange(item.variant_title)
              || (item.variant_options && window.srParseTierRange(item.variant_options[0]))
              || (item.options_with_values && item.options_with_values[0] && window.srParseTierRange(item.options_with_values[0].value));
      }
    } catch(e){}
    if (range && typeof window.srSlabChange === 'function') {
      try { window.srSlabChange(item, dir); } catch(e){}
      return;
    }

    /* v63.28 — MOQ is a FLOOR, not a step. Read from line-item properties
       ONLY — never from the variant name. Step is ALWAYS 1.
         • Below MOQ but > 0    → snap to MOQ (going up) or 0 (going down)
         • Above MOQ            → free movement, ±1 per click
       This matches the user's spec: "Below MOQ, it is 0, above MOQ, it
       can be anything." Slab name parsing (the old fallback) is removed —
       a "Pack of 150" label is not an MOQ. */
    var props = item.properties || {};
    var moq = 0;
    try {
      if (props._sr_moq) moq = parseInt(props._sr_moq, 10) || 0;
      else if (props._moq) moq = parseInt(props._moq, 10) || 0;
    } catch(e){}
    var cur = parseInt(item.quantity, 10) || 0;
    var newQty = cur + dir;
    if (newQty < 0) newQty = 0;
    if (moq && newQty > 0 && newQty < moq) {
      newQty = (dir > 0) ? moq : 0;
    }

    /* v63.30 — BULLETPROOF: no optimistic local mutation. We POST first,
       then sync Alpine from the /cart/change.js response (which IS the
       full cart per Shopify's documented behaviour). One round-trip,
       single repaint, UI is always the server's truth. */
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: newQty })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(cart){
        syncAlpineFromCart(cart);
        broadcastCart(cart);
      })
      .catch(function(){
        /* On error, pull truth from /cart.js so the user sees real state. */
        var a = findCartApp();
        if (a && typeof a.updateCart === 'function') { try { a.updateCart(false); } catch(e){} }
        broadcastCart();
      });
  };
})();

/* ============================================================
   v63.27 — PDP cart-mirror, REWRITTEN for the actual SR PDP markup.
   The Packaging PDP uses custom markup (not Paper's product__add):
     • #sr-qty-val   — the qty input (vanilla, NOT Alpine x-model)
     • .sr-qty__btn  — the -/+ buttons (inline onclick handlers)
     • #sr-atc-btn   — the Add-to-cart button (onclick=srAtcGo)
     • #sr-final-qty — hidden input name="quantity"
     • .sr-mto[data-sr-moq] — present iff product is MTO
     • .sr-pb.sr-sel[data-variant-id] — selected pack tile (variant)
     • #sr-atc-btn[data-sr-default-vid] — fallback variant id
   When the active variant is in the cart:
     1. The qty input shows the live cart quantity
     2. -/+ buttons write directly to the cart line (MOQ step for MTO,
        1 for others) instead of just changing local qty
     3. The ATC button label becomes "View Cart" and navigates to /cart
   Re-syncs on cart:refresh, cart:updated, visibilitychange, plus a
   600ms tick to catch pack-tile (variant) changes.
   ============================================================ */
(function(){
  if (!document.body || !document.body.classList.contains('product')) return;
  var D = document;

  function $(sel, c){ return (c || D).querySelector(sel); }
  function getQtyInput(){ return $('#sr-qty-val'); }
  function getAtcBtn(){ return $('#sr-atc-btn'); }
  function getQtyBtns(){
    var input = getQtyInput();
    if (!input) return null;
    var wrap = input.parentElement;
    if (!wrap) return null;
    var btns = wrap.querySelectorAll('.sr-qty__btn');
    if (btns.length < 2) return null;
    return { dec: btns[0], inc: btns[btns.length - 1], input: input };
  }
  window.srSetPdpIncartUi = function(inCart){
    var wrap = D.querySelector('.sr-qty-wrap');
    var badge = D.getElementById('sr-pdp-incart-badge');
    if (wrap) wrap.classList.toggle('sr-pdp-in-cart', !!inCart);
    if (badge) {
      badge.hidden = !inCart;
      badge.setAttribute('aria-hidden', inCart ? 'false' : 'true');
      badge.textContent = '✓ In cart';
    }
  };
  function getMoq(){
    var el = $('.sr-mto');
    if (!el) return 0;
    var n = parseInt(el.getAttribute('data-sr-moq'), 10) || 0;
    return n > 0 ? n : 0;
  }
  function getPdpQtyStep(){
    /* v55.20: after PDP reaches View Cart, the visible counter becomes a
       live cart controller. Its +/- step must match the same slab/pack step
       used before ATC. MTO remains a floor-only rule and steps by 1. */
    if (getMoq()) return 1;
    var grid = $('.sr-pack-grid');
    if (grid) {
      /* v61.x: step by the LEAST slab (smallest tier), never the selected tile —
         so from 300 the + goes to 400, not 600. */
      var first = parseInt(
        grid.getAttribute('data-smallest-tier-max') ||
        grid.getAttribute('data-first-slab') ||
        '0', 10
      ) || 0;
      if (first > 1) return first;
      var sel = $('.sr-pb.sr-sel[data-variant-id]', grid);
      if (sel && !sel.classList.contains('sr-pb--custom')) {
        var n = parseInt(
          sel.getAttribute('data-slab-size') ||
          sel.getAttribute('data-pack-qty') ||
          sel.getAttribute('data-tier-max') ||
          '0', 10
        ) || 0;
        if (n > 1) return n;
      }
    }
    var input = getQtyInput();
    var attrStep = input ? parseInt(input.getAttribute('step') || '0', 10) || 0 : 0;
    return attrStep > 1 ? attrStep : 1;
  }
  function getPdpPid(){
    var atc = getAtcBtn();
    return atc ? String(atc.getAttribute('data-sr-product-id') || '') : '';
  }
  function getPdpHandle(){
    var atc = getAtcBtn();
    return atc ? String(atc.getAttribute('data-sr-product-handle') || '') : '';
  }
  function lineHandle(it){
    if (!it) return '';
    if (it.handle) return String(it.handle);
    var m = String(it.url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function lineHasUserProps(it){
    var p = (it && it.properties) || {};
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      if (p[k] === null || p[k] === '') continue;
      if (k === '_sr_moq' || k === '_moq' || k === '_mto' || k === '_mto_present' || k === 'Made to order') continue;
      return true;
    }
    return false;
  }
  function pdpHasPackTiers(){
    var grid = $('.sr-pack-grid');
    if (!grid) return false;
    var first = parseInt(grid.getAttribute('data-first-slab') || grid.getAttribute('data-smallest-tier-max') || '0', 10) || 0;
    return first > 1 || (grid.getAttribute('data-tier-mode') || '') === 'tier-rate';
  }
  function getActiveVid(){
    /* 1. SR pack-tile selection (Packaging-style PDP — preferred). */
    var sel = $('.sr-pb.sr-sel[data-variant-id]');
    if (sel) {
      var v = sel.getAttribute('data-variant-id');
      if (v) return String(v);
    }
    /* 2. Paper Alpine's reactive current_variant_id — products that use
       Paper's variant picker (size/color dropdowns) instead of SR pack
       tiles. Without this, the mirror would only ever read the default
       variant id and never flip for non-pack-tile multi-variant products. */
    try {
      var roots = D.querySelectorAll('[x-data]');
      for (var i = 0; i < roots.length; i++) {
        var r = roots[i];
        var d = (r && r._x_dataStack && r._x_dataStack[0]) || (r && r.__x && r.__x.$data) || null;
        if (d && d.current_variant_id) return String(d.current_variant_id);
      }
    } catch(e){}
    /* 3. URL ?variant= param (Paper updates the URL when the picker changes). */
    try {
      var m = (location.search || '').match(/[?&]variant=(\d+)/);
      if (m) return String(m[1]);
    } catch(e){}
    /* 4. Fallback: default variant id baked into the ATC button. */
    var atc = getAtcBtn();
    if (atc) {
      var dv = atc.getAttribute('data-sr-default-vid');
      if (dv) return String(dv);
    }
    return null;
  }

  var lastCartQty = 0;
  var lastLineKey = null;
  var lastLine = null;
  var inflight = false;
  var origAtcHtml = null;

  function decorate(){
    var atc = getAtcBtn();
    var input = getQtyInput();
        /* v63.55: ALWAYS re-read data-sr-add-html so refreshAtcLabel's live
       price (which keeps that attribute in sync) is what gets restored
       on cart-mirror ticks. Caching origAtcHtml once at page-load froze
       the stale unitPaise × 1 string and made the ATC flicker. */
    if (atc) {
      var fresh = atc.getAttribute('data-sr-add-html');
      if (fresh) origAtcHtml = fresh;
      else if (origAtcHtml === null) origAtcHtml = atc.innerHTML;
    }


    if (lastCartQty > 0) {
      if (input && parseInt(input.value, 10) !== lastCartQty) {
        input.value = String(lastCartQty);
        try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch(e){}
      }
      if (atc) {
        atc.setAttribute('data-sr-pdp-incart', '1');
        if (typeof window.srSetPdpIncartUi === 'function') { try { window.srSetPdpIncartUi(true); } catch(e){} }
        atc.innerHTML =
          '<span style="display:inline-flex;align-items:center;gap:8px;justify-content:center;width:100%;">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7.5L6 10.5L11.5 4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            'View Cart' +
            '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="M2 5.5H9M9 5.5L6 2.5M9 5.5L6 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>';
      }
    } else {
      /* v55.18: suppress stale zero-qty cart snapshots immediately after a
         successful add. This prevents View Cart → Add to cart → View Cart flicker. */
      if (atc && atc.getAttribute('data-sr-pdp-incart') === '1' && window.srPdpIncartLockUntil && Date.now() < window.srPdpIncartLockUntil) {
        return;
      }
      if (atc && origAtcHtml !== null) {
        atc.removeAttribute('data-sr-pdp-incart');
        if (typeof window.srSetPdpIncartUi === 'function') { try { window.srSetPdpIncartUi(false); } catch(e){} }
        atc.innerHTML = origAtcHtml;
      }
    }
  }

  function applyCart(cart){
    var vid = getActiveVid(); if (!vid) return;
    var line = null;
    var pid = getPdpPid();
    var handle = getPdpHandle();
    var sameProductLines = [];
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var sameProduct = (pid && String(it.product_id) === pid) || (handle && lineHandle(it) === handle);
        if (sameProduct && !lineHasUserProps(it)) sameProductLines.push(it);
        if (!line && String(it.variant_id) === vid) line = it;
      }
    }
    var productLevel = getMoq() || pdpHasPackTiers();
    if (productLevel && sameProductLines.length) {
      var total = 0;
      sameProductLines.forEach(function(it){ total += parseInt(it.quantity, 10) || 0; });
      if (!line) line = sameProductLines[0];
      lastCartQty = total;
    } else {
      lastCartQty = line ? (line.quantity || 0) : 0;
    }
    lastLineKey = line ? line.key : null;
    lastLine = line || null;
    decorate();
  }
  function syncFromCart(eOrCart){
    /* If the cart payload is passed in (via CustomEvent detail), use it
       directly — instant repaint, zero network. */
    if (eOrCart && eOrCart.detail && eOrCart.detail.cart) {
      applyCart(eOrCart.detail.cart);
      return;
    }
    if (eOrCart && eOrCart.detail && eOrCart.detail.items && typeof eOrCart.detail.item_count !== 'undefined') {
      applyCart(eOrCart.detail);
      return;
    }
    if (eOrCart && eOrCart.items && typeof eOrCart.item_count !== 'undefined') {
      applyCart(eOrCart);
      return;
    }
    if (inflight) return;
    var vid = getActiveVid(); if (!vid) return;
    inflight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        inflight = false;
        applyCart(cart);
      })
      .catch(function(){ inflight = false; });
  }

  /* Capture-phase intercept: when item is in cart, hijack the qty +/-
     to update the cart line. The original inline onclick still fires
     after if we don't stop it — so always stop here. */
  D.addEventListener('click', function(e){
    if (lastCartQty <= 0 || !lastLineKey) return;
    var t = e.target;
    var btn = t && t.closest ? t.closest('.sr-qty__btn') : null;
    if (!btn) return;
    /* must be inside the PDP qty wrap, not a stray .sr-qty__btn elsewhere */
    var ctrls = getQtyBtns();
    if (!ctrls || (btn !== ctrls.dec && btn !== ctrls.inc)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    /* v55.20 — PDP in-cart controls respect both rules:
       - Before ATC, the inline onclick remains local-only.
       - After View Cart, this capture handler owns the click and writes the
         new quantity to Shopify immediately.
       - MTO MOQ is a floor, step is always 1.
       - Pack/tier products step by the selected slab size, not by 1. */
    var moq = getMoq();
    var dir = (btn === ctrls.dec) ? -1 : 1;
    var tierRange = null;
    try {
      if (lastLine && window.srParseTierRange) {
        tierRange = window.srParseTierRange(lastLine.variant_title)
          || (lastLine.variant_options && window.srParseTierRange(lastLine.variant_options[0]));
      }
    } catch(e){}
    if (!moq && tierRange && typeof window.srSlabChange === 'function') {
      try { window.srSlabChange(lastLine, dir); } catch(e) { syncFromCart(); }
      return;
    }
    var step = getPdpQtyStep();
    var newQty = lastCartQty + (dir * step);
    if (newQty < 0) newQty = 0;
    if (!moq && step > 1 && newQty > 0 && newQty < step) {
      newQty = 0;
    }
    if (moq && newQty > 0 && newQty < moq) {
      newQty = (dir > 0) ? moq : 0;
    }
    if (ctrls.input) {
      ctrls.input.value = String(newQty > 0 ? newQty : (moq || step || 1));
    }
    if (dir < 0) window.srSuppressCartToastUntil = Date.now() + 2000;
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lastLineKey, quantity: newQty })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(cart){
        /* Hard-sync Alpine cart from response, no extra fetch. */
        if (typeof window.srSyncAlpineFromCart === 'function') {
          try { window.srSyncAlpineFromCart(cart); } catch(e){}
        }
        applyCart(cart);
        /* Broadcast WITH the cart payload so other listeners (toast, tile
           pills) can short-circuit their own fetches. */
        if (typeof window.srBroadcastCart === 'function') {
          try { window.srBroadcastCart(cart); } catch(e){}
        } else {
          try {
            D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            D.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          } catch(e){}
        }
        if (dir < 0 && typeof window.srCartRemovedToast === 'function') {
          try { window.srCartRemovedToast(cart, getPdpHandle()); } catch(e){}
        }
      })
      .catch(function(){
        /* On error, re-pull truth from /cart.js so the PDP shows reality. */
        syncFromCart();
      });
  }, true);

  /* Capture-phase intercept on ATC: when in cart, navigate to /cart
     instead of calling srAtcGo (which would add MORE items). */
  D.addEventListener('click', function(e){
    if (lastCartQty <= 0) return;
    var atc = getAtcBtn(); if (!atc) return;
    if (e.target !== atc && !(atc.contains && atc.contains(e.target))) return;
    e.preventDefault();
    e.stopPropagation();
    if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) return; window.location.href = '/cart';
  }, true);

  /* Variant change detection (pack-tile clicks). The pack selector script
     toggles .sr-sel — we poll the active vid every 600ms. Cheap, robust. */
  var lastVid = null;
  setInterval(function(){
    var vid = getActiveVid();
    if (vid && vid !== lastVid) {
      lastVid = vid;
      if (window.srCartCache && window.srCartCache.items) syncFromCart(window.srCartCache);
      else if (window.__initialData && window.__initialData.cart && window.__initialData.cart.items) syncFromCart(window.__initialData.cart);
      syncFromCart();
    }
  }, 600);

  D.addEventListener('cart:refresh', syncFromCart);
  D.addEventListener('cart:updated', syncFromCart);
  D.addEventListener('visibilitychange', function(){ if (!D.hidden) syncFromCart(); });

  function initialSync(){
    /* Use the server-rendered cart object immediately, so PDP products
       already in cart become View Cart on first paint. /cart.js still runs
       right after to obtain the authoritative line key for +/- updates. */
    if (window.__initialData && window.__initialData.cart && window.__initialData.cart.items) {
      try { window.srCartCache = window.__initialData.cart; } catch(e){}
      applyCart(window.__initialData.cart);
    } else if (window.srCartCache && window.srCartCache.items) {
      applyCart(window.srCartCache);
    }
    syncFromCart();
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }
})();


/* ============================================================
   v63.40 — Global SR card ATC state for MTO + variant-step products.
   Applies to home, collection, search, recommendations and recently viewed.
   Rules:
     • MTO: MOQ is only a floor. First add = MOQ, then +/- 1; below MOQ = 0.
     • Variant/tier products: quantity is always a multiple of min variant qty.
       +/- moves by that min variant qty and tier-range variants are swapped.
   ============================================================ */
(function(){
  var D = document;
  var productCache = {};
  function qsa(sel, root){ return Array.prototype.slice.call((root || D).querySelectorAll(sel)); }
  function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }
  function cartCache(){ return window.srCartCache || { items: [], item_count: 0 }; }
  function setCartCache(cart){ if (cart && cart.items) window.srCartCache = cart; }
  function formVid(form){ return String((form.querySelector('input[name="id"]') || {}).value || form.getAttribute('data-vid') || ''); }
  function formPid(form){ return String(form.getAttribute('data-product-id') || ''); }
  function formHandle(form){
    var h = form.getAttribute('data-product-handle') || '';
    if (h) return h;
    var card = closest(form, '.sr-pcard,.sr-pg__card,article');
    var a = card && card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href') && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function itemHandle(it){
    if (!it) return '';
    if (it.handle) return String(it.handle);
    var u = it.url || '';
    var m = String(u).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function isMto(form){
    var mode = String(form.getAttribute('data-sr-mode') || '').toLowerCase().replace(/[\s-]+/g, '_');
    if (mode === 'mto' || mode === 'made_to_order') return true;
    var card = closest(form, '.sr-pcard,.sr-pg__card,article');
    if (!card) return false;
    if (card.querySelector('.sr-flair--mto,[aria-label="Made to order"],[aria-label="MTO"]')) return true;
    var flair = card.querySelector('.sr-flair,.sr-pdp-flair,[class*="flair"]');
    var txt = flair ? String(flair.textContent || '').toLowerCase().replace(/[\s-]+/g, '_') : '';
    return txt.indexOf('made_to_order') !== -1 || txt === 'mto';
  }
  function moqFor(form){
    if (!isMto(form)) return 0;
    var n = parseInt(form.getAttribute('data-sr-moq'), 10) || 1;
    return n > 1 ? n : 1;
  }
  function isVariantStep(form){
    if (isMto(form)) return false;
    var mode = (form.getAttribute('data-sr-mode') || '').toLowerCase();
    var step = parseInt(form.getAttribute('data-sr-step'), 10) || parseInt(form.getAttribute('data-sr-slab'), 10) || 1;
    return mode === 'variant-step' || step > 1;
  }
  function stepFor(form){
    if (isMto(form)) return 1;
    var s = parseInt(form.getAttribute('data-sr-step'), 10) || parseInt(form.getAttribute('data-sr-slab'), 10) || 1;
    return s > 1 ? s : 1;
  }
  function floorFor(form){ return isMto(form) ? moqFor(form) : stepFor(form); }
  function parseRange(s){
    if (window.srParseTierRange) {
      var r = window.srParseTierRange(s); if (r) return r;
    }
    var m = String(s || '').trim().match(/^\s*(\d+)\s*[-–—]\s*(\d+)\s*$/);
    if (!m) return null;
    var lo = parseInt(m[1],10), hi = parseInt(m[2],10);
    return hi >= lo ? { min: lo, max: hi } : null;
  }
  function hasUserLineProps(it){
    /* Generic tile controls must not silently merge/delete cart lines that
       carry shopper-entered properties such as custom design remarks. Known
       SR technical flags are safe; anything else is treated as user data. */
    var p = (it && it.properties) || {};
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      if (p[k] === null || p[k] === '') continue;
      if (k === '_sr_moq' || k === '_moq' || k === '_mto' || k === '_mto_present' || k === 'Made to order') continue;
      return true;
    }
    return false;
  }
  function sameProductLine(form, it){
    if (!it) return false;
    var pid = formPid(form), handle = formHandle(form);
    return !!((pid && String(it.product_id) === pid) || (handle && itemHandle(it) === handle));
  }
  function linesFor(form, cart){
    cart = cart || cartCache();
    var vid = formVid(form);
    var exact = [];
    var managedSameProduct = [];
    (cart.items || []).forEach(function(it){
      if (vid && String(it.variant_id) === vid) exact.push(it);
      if ((isVariantStep(form) || isMto(form)) && sameProductLine(form, it) && !hasUserLineProps(it)) managedSameProduct.push(it);
    });
    /* Variant/tier products are pricing tiers, not separate shopper choices.
       Therefore the card counter must show TOTAL same-product qty across
       tier variants, while preserving any custom-remark/property lines.
       MTO is product-level too: ignore variants and manage standard MTO lines
       as one product-level quantity. */
    if (isVariantStep(form) || isMto(form)) return managedSameProduct.length ? managedSameProduct : exact;
    return exact;
  }
  function exactLineFirst(form, lines){
    var vid = formVid(form);
    var exact = null;
    lines.forEach(function(it){ if (!exact && vid && String(it.variant_id) === vid) exact = it; });
    return exact || lines[0] || null;
  }
  function totalQty(lines){
    var total = 0;
    (lines || []).forEach(function(line){ total += parseInt(line.quantity,10) || 0; });
    return total;
  }
  function updateCount(count){
    if (typeof count === 'undefined' || count === null) return;
    qsa('[data-cart-count], .header__cart-count, .cart-icon-bubble, [class*="cart-count"], [class*="cart_count"], [class*="cart-bubble"]').forEach(function(el){
      function walk(node){
        for (var i = 0; i < node.childNodes.length; i++) {
          var n = node.childNodes[i];
          if (n.nodeType === 3) { n.nodeValue = String(count); return true; }
          if (n.nodeType === 1 && walk(n)) return true;
        }
        return false;
      }
      if (!walk(el)) el.textContent = String(count);
    });
  }
  function broadcast(cart){
    setCartCache(cart);
    if (cart && typeof window.srSyncAlpineFromCart === 'function') { try { window.srSyncAlpineFromCart(cart); } catch(e) {} }
    if (cart && typeof cart.item_count !== 'undefined') updateCount(cart.item_count);
    if (typeof window.srBroadcastCart === 'function') { try { window.srBroadcastCart(cart); return; } catch(e) {} }
    try { D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })); } catch(e) {}
    try { D.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); } catch(e) {}
  }
  function fetchCart(){
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(cart){ broadcast(cart); return cart; })
      .catch(function(){ return null; });
  }
  function fetchProduct(handle){
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials:'same-origin', headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ if (p) productCache[handle] = p; return p; })
      .catch(function(){ return null; });
  }
  function pickVariantForQty(form, qty){
    var fallback = parseInt(formVid(form), 10) || 0;
    if (!isVariantStep(form)) return Promise.resolve(fallback);
    var handle = formHandle(form);
    return fetchProduct(handle).then(function(product){
      if (!product || !product.variants || !product.variants.length) return fallback;
      var ranged = [];
      product.variants.forEach(function(v){
        var r = parseRange(v.title) || parseRange(v.option1);
        if (r) ranged.push({ id: v.id, range: r });
      });
      if (ranged.length) {
        ranged.sort(function(a,b){ return a.range.max - b.range.max; });
        for (var i=0;i<ranged.length;i++) {
          if (qty >= ranged[i].range.min && qty <= ranged[i].range.max) return ranged[i].id;
        }
        return ranged[ranged.length - 1].id;
      }
      return fallback;
    });
  }
  function propsFor(form){
    if (!isMto(form)) return null;
    return { '_sr_moq': String(moqFor(form)), 'Made to order': 'Yes' };
  }
  function cleanupDuplicatePills(form){
    /* Final guard: older theme builds may have already injected a legacy v28
       pill before this controller runs. Keep one direct sibling pill only, so
       Recently Viewed / Recommendations never show double - qty + controls. */
    try {
      if (!form || !form.parentNode) return;
      var pills = Array.prototype.slice.call(form.parentNode.querySelectorAll(':scope > .sr-pcard__pill'));
      if (pills.length <= 1) return;
      var keep = form._srPill && pills.indexOf(form._srPill) > -1 ? form._srPill : pills[0];
      pills.forEach(function(p){ if (p !== keep && p.parentNode) p.parentNode.removeChild(p); });
      form._srPill = keep;
    } catch(e) {}
  }
  function ensurePill(form){
    cleanupDuplicatePills(form);
    var pill = form._srPill || (form.parentNode && form.parentNode.querySelector(':scope > .sr-pcard__pill'));
    if (!pill) {
      pill = D.createElement('div');
      pill.className = 'sr-pcard__pill';
      pill.hidden = true;
      pill.style.cssText = 'display:none;align-items:center;background:#0E0E0C;border-radius:100px;height:32px;overflow:hidden;align-self:flex-start;width:max-content;max-width:100%;flex:0 0 auto;box-sizing:border-box;transition:transform .18s cubic-bezier(.34,1.56,.64,1)';
      pill.innerHTML = '<button type="button" aria-label="Decrease" data-d="-1" style="width:30px;height:32px;background:transparent;border:none;color:#F5F1E8;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif">−</button><span class="sr-pcard__pill-val" style="min-width:34px;padding:0 4px;text-align:center;font-size:12.5px;font-weight:600;color:#F5F1E8;font-family:Inter,system-ui,sans-serif;font-variant-numeric:tabular-nums lining-nums">0</span><button type="button" aria-label="Increase" data-d="1" style="width:30px;height:32px;background:transparent;border:none;color:#F5F1E8;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif">+</button>';
      if (form.parentNode) form.parentNode.appendChild(pill);
    }
    form._srPill = pill;
    form._srVid = formVid(form);
    form._srSetQtyExternal = function(){ syncOne(form, cartCache(), false); };
    return pill;
  }
  function setVisual(form, qty){
    qty = parseInt(qty, 10) || 0;
    var pill = ensurePill(form);
    var val = pill.querySelector('.sr-pcard__pill-val');
    form._srQtyLocal = qty;
    if (val) val.textContent = String(qty);
    if (qty > 0) {
      form.hidden = true; form.style.display = 'none';
      pill.hidden = false; pill.style.display = 'inline-flex';
    } else {
      form.hidden = false; form.style.display = '';
      pill.hidden = true; pill.style.display = 'none';
    }
  }
  function bump(form){
    var pill = ensurePill(form);
    pill.style.transform = 'scale(1.12)';
    setTimeout(function(){ pill.style.transform = 'scale(1)'; }, 160);
  }
  function optimisticCount(delta){
    var cart = cartCache();
    if (typeof cart.item_count === 'number') updateCount(Math.max(0, cart.item_count + delta));
  }
  function nextQty(form, cur, dir, isAdd){
    cur = parseInt(cur,10) || 0;
    var floor = floorFor(form), step = stepFor(form);
    if (isMto(form)) {
      if (isAdd) return cur > 0 ? cur + 1 : floor;
      var n = cur + dir;
      if (n < 0) n = 0;
      if (n > 0 && n < floor) n = dir > 0 ? floor : 0;
      return n;
    }
    if (isVariantStep(form)) {
      var n2 = cur + (dir > 0 || isAdd ? step : -step);
      return n2 > 0 ? n2 : 0;
    }
    return isAdd ? cur + 1 : Math.max(0, cur + dir);
  }
  function addVariant(vid, qty, props){
    var item = { id: parseInt(vid, 10), quantity: Math.max(0, qty) };
    if (props) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(fetchCart);
  }
  function changeLine(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); });
  }
  function mergedProps(base, extra){
    var out = {};
    try {
      if (base) {
        for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k) && base[k] !== null && base[k] !== '') out[k] = String(base[k]);
      }
      if (extra) {
        for (var j in extra) if (Object.prototype.hasOwnProperty.call(extra, j) && extra[j] !== null && extra[j] !== '') out[j] = String(extra[j]);
      }
    } catch(e){}
    return Object.keys(out).length ? out : null;
  }
  function setProductQty(form, targetQty){
    targetQty = Math.max(0, parseInt(targetQty, 10) || 0);
    var lines = linesFor(form, cartCache());
    var primary = exactLineFirst(form, lines);
    function removeManagedLines(){
      var seq = Promise.resolve(null);
      (lines || []).forEach(function(line){
        if (line && line.key) seq = seq.then(function(){ return changeLine(line.key, 0).catch(function(){ return null; }); });
      });
      return seq;
    }
    if (targetQty <= 0) {
      if (!lines.length) return fetchCart();
      return removeManagedLines().then(fetchCart);
    }
    return pickVariantForQty(form, targetQty).then(function(vid){
      if (!vid) vid = parseInt(formVid(form),10) || 0;
      var props = mergedProps(primary && primary.properties, propsFor(form));
      /* If exactly one managed line is already on the right variant, change it.
         If multiple tier lines exist, collapse ONLY those no-user-property
         managed lines into one correctly priced tier line. */
      if (primary && primary.key && lines.length === 1 && String(primary.variant_id) === String(vid)) {
        return changeLine(primary.key, targetQty).then(function(cart){ broadcast(cart); return cart; });
      }
      return removeManagedLines().then(function(){ return addVariant(vid, targetQty, props); });
    });
  }
  function cardLocked(form){
    return !!(form && (form._srBusy || (form._srLockUntil && Date.now() < form._srLockUntil)));
  }
  function lockCard(form){
    if (form) form._srLockUntil = Date.now() + 2400;
  }
  function unlockCard(form){
    if (form) form._srLockUntil = 0;
  }
  function syncOne(form, cart, force){
    /* v63.46 — do not let stale global cart syncs clobber a tile that has
       just been clicked. Without this, sequence was: local pill appears →
       an older /cart.js sync sees qty 0 and shows + → confirmed cart response
       shows pill again. */
    if (!force && cardLocked(form)) return;
    cleanupDuplicatePills(form);
    ensurePill(form);
    setVisual(form, totalQty(linesFor(form, cart)));
  }
  function syncVisibleCards(cart){
    if (cart) setCartCache(cart);
    qsa('.sr-pcard__atc-form').forEach(function(form){ syncOne(form, cartCache()); });
  }

  D.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;

    var pdpView = t.closest('#sr-atc-btn[data-sr-pdp-incart]');
    if (pdpView) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) return; window.location.href = '/cart';
      return;
    }

    var addBtn = t.closest('.sr-pcard__atc-form .sr-pcard__add');
    if (addBtn) {
      var form = closest(addBtn, '.sr-pcard__atc-form');
      if (!form) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (form._srBusy) return;
      var cur = Math.max(totalQty(linesFor(form, cartCache())), parseInt(form._srQtyLocal,10) || 0);
      var target = nextQty(form, cur, 1, true);
      var delta = target - cur;
      form._srBusy = true;
      lockCard(form);
      addBtn.classList.add('sr-pcard__add--loading');
      setVisual(form, target); bump(form); optimisticCount(delta);
      setProductQty(form, target).then(function(cart){
        form._srBusy = false; unlockCard(form); addBtn.classList.remove('sr-pcard__add--loading');
        if (cart && cart.items) {
          syncOne(form, cart, true);
          if (delta > 0 && window.srCartToast && typeof window.srCartToast.showFromCart === 'function') {
            try { window.srCartToast.showFromCart(cart, formVid(form), formHandle(form)); } catch(e) {}
          }
        }
      }).catch(function(){
        form._srBusy = false; unlockCard(form); addBtn.classList.remove('sr-pcard__add--loading'); fetchCart();
      });
      return;
    }

    var pillBtn = t.closest('.sr-pcard__pill button[data-d]');
    if (pillBtn) {
      var pill = closest(pillBtn, '.sr-pcard__pill');
      var wrap = pill && pill.parentNode;
      var form = wrap && wrap.querySelector('.sr-pcard__atc-form');
      if (!form) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (form._srBusy) return;
      var dir = parseInt(pillBtn.getAttribute('data-d'), 10) || 0;
      var cur2 = Math.max(totalQty(linesFor(form, cartCache())), parseInt(form._srQtyLocal,10) || 0);
      var target2 = nextQty(form, cur2, dir, false);
      var delta2 = target2 - cur2;
      form._srBusy = true;
      lockCard(form);
      if (dir < 0) window.srSuppressCartToastUntil = Date.now() + 2000;
      setVisual(form, target2); bump(form); optimisticCount(delta2);
      setProductQty(form, target2).then(function(cart){
        form._srBusy = false; unlockCard(form);
        if (cart && cart.items) {
          syncOne(form, cart, true);
          if (dir > 0 && window.srCartToast && typeof window.srCartToast.showFromCart === 'function') {
            try { window.srCartToast.showFromCart(cart, formVid(form), formHandle(form)); } catch(e) {}
          }
        }
        if (dir < 0 && typeof window.srCartRemovedToast === 'function') {
          try { window.srCartRemovedToast(cart, formHandle(form)); } catch(e) {}
        }
      }).catch(function(){ form._srBusy = false; unlockCard(form); fetchCart(); });
    }
  }, true);

  D.addEventListener('cart:refresh', function(e){ if (e.detail && e.detail.cart) syncVisibleCards(e.detail.cart); });
  D.addEventListener('cart:updated', function(e){ if (e.detail && e.detail.cart) syncVisibleCards(e.detail.cart); });
  D.addEventListener('sr:cards-injected', function(){ syncVisibleCards(); });

  function initialCardSync(){
    if (window.__initialData && window.__initialData.cart && window.__initialData.cart.items) {
      window.srCartCache = window.__initialData.cart;
      syncVisibleCards(window.__initialData.cart);
    } else if (window.srCartCache && window.srCartCache.items) {
      syncVisibleCards(window.srCartCache);
    } else {
      syncVisibleCards();
    }
    fetchCart().then(syncVisibleCards);
  }
  try {
    var mo = new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n && n.nodeType === 1 && ((n.matches && n.matches('.sr-pcard__atc-form,.sr-pcard')) || (n.querySelector && n.querySelector('.sr-pcard__atc-form')))) {
            syncVisibleCards(window.srCartCache || (window.__initialData && window.__initialData.cart));
            return;
          }
        }
      }
    });
    mo.observe(D.documentElement, { childList: true, subtree: true });
  } catch(e){}
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', initialCardSync);
  else initialCardSync();
})();


/* ============================================================
   v63.41 — final cart semantics patch.
   - MTO / Made-to-order is product-level and ignores variant tiering.
   - Tier variants are price tiers: total same-product qty picks the correct
     tier variant, so 100 + 100 is charged as the 200 tier.
   - Custom/property lines are never merged or deleted.
   - Negative qty actions suppress the add toast and show a removed/updated toast.
   ============================================================ */
(function(){
  var D = document;
  var productCache = {};
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function itemHandle(it){ if(!it) return ''; if(it.handle) return String(it.handle); var m=String(it.url||'').match(/\/products\/([^/?#]+)/); return m?m[1]:''; }
  function hasUserProps(it){ var p=(it&&it.properties)||{}; for(var k in p){ if(!Object.prototype.hasOwnProperty.call(p,k)) continue; if(p[k]===null||p[k]==='') continue; if(k==='_sr_moq'||k==='_moq'||k==='_mto'||k==='_mto_present'||k==='Made to order') continue; return true; } return false; }
  function isMtoLine(it){ var p=(it&&it.properties)||{}; return !!(p['_sr_moq']||p['_moq']||p['_mto']||p['_mto_present']||p['Made to order']); }
  function lineMoq(it){ var p=(it&&it.properties)||{}; return parseInt(p['_sr_moq']||p['_moq']||0,10)||0; }
  function parseRange(s){ if(window.srParseTierRange){ var r=window.srParseTierRange(s); if(r) return r; } var m=String(s||'').trim().match(/^\s*(\d+)\s*[-–—]\s*(\d+)\s*$/); if(!m) return null; var a=parseInt(m[1],10), b=parseInt(m[2],10); return b>=a?{min:a,max:b}:null; }
  function fetchCart(){ return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():Promise.reject(r);}); }
  function broadcast(cart){ try{ window.srCartCache=cart; }catch(e){} if(cart&&typeof window.srSyncAlpineFromCart==='function'){try{window.srSyncAlpineFromCart(cart);}catch(e){}} if(typeof window.srBroadcastCart==='function'){try{window.srBroadcastCart(cart);return;}catch(e){}} try{D.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));}catch(e){} try{D.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}}));}catch(e){} }
  function fetchProduct(handle){ if(!handle) return Promise.resolve(null); if(productCache[handle]) return Promise.resolve(productCache[handle]); return fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){ if(p) productCache[handle]=p; return p; }).catch(function(){return null;}); }
  function productLines(cart,item){ var pid=item&&item.product_id?String(item.product_id):''; var h=itemHandle(item); return ((cart&&cart.items)||[]).filter(function(x){ return !hasUserProps(x) && ((pid&&String(x.product_id)===pid)||(h&&itemHandle(x)===h)); }); }
  function carryProps(line){ var out={}; var p=(line&&line.properties)||{}; for(var k in p){ if(Object.prototype.hasOwnProperty.call(p,k) && p[k]!==null && p[k]!=='') out[k]=String(p[k]); } return Object.keys(out).length?out:null; }
  function cartChange(key,qty){ return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,qty)})}).then(function(r){return r.ok?r.json():Promise.reject(r);}); }
  function cartAdd(vid,qty,props){ var body={id:parseInt(vid,10),quantity:Math.max(0,qty)}; if(props) body.properties=props; return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.ok?r.json():Promise.reject(r);}); }
  function showRemoved(cart, handle){
    try { window.srSuppressCartToastUntil = Date.now() + 2000; } catch(e){}
    var existing = D.querySelector('.sr-toast'); if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var line = null, items=(cart&&cart.items)||[];
    if(handle){ for(var i=0;i<items.length;i++){ if(itemHandle(items[i])===handle){ line=items[i]; break; } } }
    var title = line ? (line.product_title || line.title || 'Cart updated') : 'Cart updated';
    var img = line && (line.image || (line.featured_image && line.featured_image.url)); if(img && img.indexOf('//')===0) img='https:'+img;
    var t=D.createElement('div'); t.className='sr-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite');
    t.innerHTML='<button type="button" class="sr-toast__close" aria-label="Dismiss">×</button>'+
      '<div class="sr-toast__head"><span class="sr-toast__check" aria-hidden="true">−</span><span class="sr-toast__label">Removed from cart</span><span class="sr-toast__count">'+((cart&&cart.item_count)||0)+' items</span></div>'+
      '<div class="sr-toast__body">'+(img?'<div class="sr-toast__img"><img src="'+esc(img).replace(/(\.(?:png|jpg|jpeg|webp))(\?|$)/i,'_120x$1$2')+'" alt="" loading="lazy"></div>':'<div class="sr-toast__img sr-toast__img--blank" aria-hidden="true"></div>')+
      '<div class="sr-toast__meta"><div class="sr-toast__title">'+esc(title)+'</div></div></div>'+
      '<div class="sr-toast__actions"><a href="/cart" class="sr-toast__cta sr-toast__cta--ghost">View cart</a><a href="/cart#shiprocket-checkout" class="sr-toast__cta sr-toast__cta--primary">Checkout →</a></div><div class="sr-toast__progress"><span></span></div>';
    D.body.appendChild(t); requestAnimationFrame(function(){t.classList.add('sr-toast--in');});
    var timer=setTimeout(close,1400); function close(){clearTimeout(timer);t.classList.remove('sr-toast--in');t.classList.add('sr-toast--out');setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t);},320);} var c=t.querySelector('.sr-toast__close'); if(c)c.addEventListener('click',close);
  }
  window.srCartRemovedToast = showRemoved;

  function tierInfo(product){ var out=[]; if(product&&product.variants){ product.variants.forEach(function(v){ var r=parseRange(v.title)||parseRange(v.option1); if(r) out.push({id:v.id,range:r}); }); } out.sort(function(a,b){return a.range.max-b.range.max;}); return out; }
  function pickTier(tiers, qty, fallback){ if(!tiers.length) return fallback; for(var i=0;i<tiers.length;i++){ if(qty>=tiers[i].range.min && qty<=tiers[i].range.max) return tiers[i].id; } return tiers[tiers.length-1].id; }
  function setTierTotalFromLine(item, dir){
    window.srSuppressCartToastUntil = Date.now() + 2200;
    return fetchCart().then(function(cart){
      var lines=productLines(cart,item); if(!lines.length) lines=[item];
      var total=0; lines.forEach(function(l){ total += parseInt(l.quantity,10)||0; });
      var handle=itemHandle(item); return fetchProduct(handle).then(function(product){
        var tiers=tierInfo(product); if(!tiers.length){ return simpleStep(item,dir,cart); }
        var step=tiers[0].range.max || 1;
        var target=total + ((dir<0?-1:1)*step); if(target<0) target=0;
        var props=carryProps(lines[0]);
        var seq=Promise.resolve(null);
        lines.forEach(function(l){ if(l&&l.key) seq=seq.then(function(){return cartChange(l.key,0).catch(function(){return null;});}); });
        if(target<=0){ return seq.then(fetchCart).then(function(c){broadcast(c); if(dir<0)showRemoved(c,handle); return c;}); }
        var vid=pickTier(tiers,target,item.variant_id||item.id);
        return seq.then(function(){return cartAdd(vid,target,props);}).then(fetchCart).then(function(c){broadcast(c); if(dir<0)showRemoved(c,handle); return c;});
      });
    }).catch(function(){ try{var a=document.querySelector('[x-data]');}catch(e){} });
  }
  function simpleStep(item,dir,cart){
    var moq=lineMoq(item), cur=parseInt(item.quantity,10)||0, target=cur+(dir<0?-1:1);
    if(target<0) target=0; if(moq && target>0 && target<moq) target=(dir>0)?moq:0;
    window.srSuppressCartToastUntil = Date.now() + 2200;
    return cartChange(item.key,target).then(function(c){broadcast(c); if(dir<0)showRemoved(c,itemHandle(item)); return c;});
  }

  window.srSlabChange = function(item, dir){
    if(!item) return false; dir=(dir<0)?-1:1;
    if(isMtoLine(item)) { simpleStep(item,dir); return true; }
    var r=parseRange(item.variant_title)||(item.variant_options&&parseRange(item.variant_options[0]))||(item.options_with_values&&item.options_with_values[0]&&parseRange(item.options_with_values[0].value));
    if(r){ setTierTotalFromLine(item,dir); return true; }
    simpleStep(item,dir); return true;
  };
  window.srStepCartLine = function(item, dir){
    if(!item || !item.key) return;
    dir=(dir<0)?-1:1;
    if(isMtoLine(item)) { simpleStep(item,dir); return; }
    var r=parseRange(item.variant_title)||(item.variant_options&&parseRange(item.variant_options[0]))||(item.options_with_values&&item.options_with_values[0]&&parseRange(item.options_with_values[0].value));
    if(r) setTierTotalFromLine(item,dir); else simpleStep(item,dir);
  };
})();

/* ============================================================
   v63.44 — PDP sticky-until-original ATC clone.
   The real .sr-qty-wrap stays the source of truth. This fixed clone is shown
   only while the real PDP quantity/ATC block is below the viewport, so ATC is
   visible on landing but behaves normally once the shopper reaches the section.
   ============================================================ */
(function(){
  if (!document.body || !document.body.classList.contains('product')) return;
  var D = document;
  function qs(s, c){ return (c || D).querySelector(s); }
  function qsa(s, c){ return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function ready(fn){ if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function(){
    var wrap = qs('.sr-qty-wrap');
    var input = qs('#sr-qty-val');
    var btn = qs('#sr-atc-btn');
    if (!wrap || !input || !btn) return;

    var nativeBtns = qsa('.sr-qty__btn', wrap);
    if (nativeBtns.length < 2) return;

    var sticky = D.createElement('div');
    sticky.className = 'sr-pdp-sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML =
      '<div class="sr-pdp-sticky-atc__inner">' +
        '<div class="sr-pdp-sticky-atc__qty" aria-label="Quantity">' +
          '<button type="button" class="sr-pdp-sticky-atc__minus" aria-label="Decrease quantity">−</button>' +
          '<span class="sr-pdp-sticky-atc__val"></span>' +
          '<button type="button" class="sr-pdp-sticky-atc__plus" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="sr-pdp-sticky-atc__btn"></button>' +
      '</div>';
    D.body.appendChild(sticky);

    var sVal = qs('.sr-pdp-sticky-atc__val', sticky);
    var sMinus = qs('.sr-pdp-sticky-atc__minus', sticky);
    var sPlus = qs('.sr-pdp-sticky-atc__plus', sticky);
    var sBtn = qs('.sr-pdp-sticky-atc__btn', sticky);

    function cleanButtonText(){
      var txt = String(btn.textContent || '').replace(/\s+/g, ' ').trim();
      return txt || 'Add to cart';
    }
    function sync(){
      if (!D.body.contains(wrap) || !D.body.contains(btn) || !D.body.contains(input)) return;
      if (sVal) sVal.textContent = String(parseInt(input.value, 10) || 0);
      if (sBtn) {
        sBtn.innerHTML = btn.innerHTML;
        sBtn.disabled = !!btn.disabled;
        sBtn.setAttribute('aria-label', cleanButtonText());
      }
      updateVisibility();
    }
    function updateVisibility(){
      if (!wrap || !sticky) return;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || D.documentElement.clientHeight || 0;
      /* Show ONLY while the real block is still below the fold (not yet reached).
         Once it's in view OR has scrolled up past the top, stay hidden — don't
         reappear. (Previously also showed on rect.bottom < 8, which made it pop
         back up after you scrolled past the ATC.) */
      var shouldShow = (rect.top > (vh - 8));
      sticky.classList.toggle('sr-pdp-sticky-atc--show', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }
    function clickNative(which){
      var b = which === 'minus' ? nativeBtns[0] : nativeBtns[nativeBtns.length - 1];
      if (!b) return;
      b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(sync, 40);
      setTimeout(sync, 450);
    }

    if (sMinus) sMinus.addEventListener('click', function(e){ e.preventDefault(); clickNative('minus'); });
    if (sPlus) sPlus.addEventListener('click', function(e){ e.preventDefault(); clickNative('plus'); });
    if (sBtn) sBtn.addEventListener('click', function(e){
      e.preventDefault();
      if (btn.getAttribute('data-sr-pdp-incart') === '1') { if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) return; window.location.href = '/cart'; return; }
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(sync, 80);
      setTimeout(sync, 700);
    });

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    D.addEventListener('cart:refresh', function(){ setTimeout(sync, 20); });
    D.addEventListener('cart:updated', function(){ setTimeout(sync, 20); });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });

    try {
      var mo = new MutationObserver(sync);
      mo.observe(btn, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-sr-pdp-incart'] });
      mo.observe(input, { attributes: true, attributeFilter: ['value'] });
    } catch(e) {}

    sync();
    setTimeout(sync, 250);
    setTimeout(sync, 900);
  });
})();


/* ============================================================
   v63.50 — final UX/payment/navigation safety net.
   1) Mobile cart quantities do not clip 100/1000.
   2) MTO flag is synced after every cart mutation so checkout can suppress COD.
   3) Toast checkout CTA attempts direct Shiprocket headless checkout from current page.
   4) PDP tier click cannot leave the visible counter on the clicked variant slab when item is already in cart.
   ============================================================ */
(function(){
  var D = document;
  function qs(s,c){ return (c||D).querySelector(s); }
  function qsa(s,c){ return Array.prototype.slice.call((c||D).querySelectorAll(s)); }
  function cartFetch(){ return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}); }
  function hasMto(cart){
    return !!(cart && cart.items && cart.items.some(function(it){
      var p = it.properties || {};
      return !!(p['Made to order'] || p['_mto'] || p['_mto_present'] || p['_sr_moq'] || p['_moq']);
    }));
  }
  var mtoSyncTimer = null;
  function syncMtoFlag(){
    clearTimeout(mtoSyncTimer);
    mtoSyncTimer = setTimeout(function(){
      cartFetch().then(function(cart){
        if(!cart) return;
        try { window.srCartCache = cart; } catch(e){}
        var want = hasMto(cart) ? 'yes' : '';
        var cur = (cart.attributes && cart.attributes._mto_present) || '';
        if(cur === want) return;
        return fetch('/cart/update.js',{
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({attributes:{_mto_present:want, mto_present:want}})
        }).catch(function(){});
      });
    }, 120);
  }
  window.srSyncMtoFlag = syncMtoFlag;
  D.addEventListener('cart:updated', syncMtoFlag);
  D.addEventListener('cart:refresh', syncMtoFlag);
  D.addEventListener('DOMContentLoaded', syncMtoFlag);
  if(D.readyState !== 'loading') syncMtoFlag();

  function clickShiprocketCheckout(){
    var direct = qs('.shiprocket-headless button, .shiprocket-headless a, .sr-headless-checkout, button[class*="shiprocket" i], a[class*="shiprocket" i], button[class*="fastrr" i], a[class*="fastrr" i]');
    if(direct){ try{ direct.click(); return true; }catch(e){} }
    var host = qs('#sr-toast-headless-host');
    if(!host){
      host = D.createElement('div');
      host.id = 'sr-toast-headless-host';
      host.className = 'shiprocket-headless';
      host.setAttribute('data-type','mini-cart');
      host.style.cssText = 'position:absolute!important;left:-9999px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;';
      D.body.appendChild(host);
    }
    var start = Date.now();
    (function poll(){
      var btn = qs('#sr-toast-headless-host button, #sr-toast-headless-host a, .shiprocket-headless button, .shiprocket-headless a, .sr-headless-checkout');
      if(btn){ try{ btn.click(); return; }catch(e){} }
      if(Date.now() - start < 1400) return setTimeout(poll, 80);
      window.location.href = '/cart#shiprocket-checkout';
    })();
    return true;
  }
  D.addEventListener('click', function(e){
    var cta = e.target && e.target.closest ? e.target.closest('.sr-toast__cta--primary') : null;
    if(!cta) return;
    e.preventDefault(); e.stopPropagation();
    clickShiprocketCheckout();
  }, true);

  /* PDP product-total counter guard after pack tile clicks. */
  D.addEventListener('click', function(e){
    var tile = e.target && e.target.closest ? e.target.closest('.sr-pack-grid .sr-pb') : null;
    if(!tile) return;
    setTimeout(function(){
      var btn = qs('#sr-atc-btn[data-sr-pdp-incart="1"]');
      var input = qs('#sr-qty-val');
      var cart = window.srCartCache || (window.__initialData && window.__initialData.cart);
      if(!btn || !input || !cart || !cart.items) return;
      var pid = String(btn.getAttribute('data-sr-product-id') || '');
      var handle = String(btn.getAttribute('data-sr-product-handle') || '');
      var total = 0;
      cart.items.forEach(function(it){
        var h = String(it.handle || ((String(it.url||'').match(/\/products\/([^/?#]+)/)||[])[1] || ''));
        var p = it.properties || {}, userProps = false;
        for(var k in p){ if(Object.prototype.hasOwnProperty.call(p,k) && p[k] && !(/^_/.test(k)) && k !== 'Made to order') userProps = true; }
        if(userProps) return;
        if((pid && String(it.product_id)===pid) || (handle && h===handle)) total += parseInt(it.quantity,10)||0;
      });
      if(total > 0 && String(input.value) !== String(total)){
        input.value = String(total);
        try{ input.dispatchEvent(new Event('input',{bubbles:true})); }catch(e){}
        try{ input.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
      }
    }, 0);
  }, true);
})();
/* v42.1 — desktop header hover persistence.
   Click-dropdown mode renders top-level parents as buttons; Paper keeps the
   mega panel at h-0 until click. This adds a class that opens it on hover/
   focus and keeps it alive for 220ms while the cursor crosses the label-to-
   panel gap. */
(function(){
  function initSrMenuHoverPersistence(){
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('header .sr-top-header-nav .flex-shrink > .header__dropdown').forEach(function(panel){
      var item = panel.parentElement;
      if (!item || item.dataset.srMenuHoverReady === '1') return;
      item.dataset.srMenuHoverReady = '1';
      var closeTimer = null;
      function open(){
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = null;
        item.classList.add('sr-menu-hover-open');
      }
      function scheduleClose(){
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function(){
          if (!item.matches(':hover') && !item.contains(document.activeElement)) {
            item.classList.remove('sr-menu-hover-open');
          }
        }, 220);
      }
      item.addEventListener('mouseenter', open);
      item.addEventListener('focusin', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusout', scheduleClose);
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', scheduleClose);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSrMenuHoverPersistence);
  } else {
    initSrMenuHoverPersistence();
  }
  document.addEventListener('shopify:section:load', initSrMenuHoverPersistence);
})();


/* ============================================================
   v55.29 final cleanup patch
   - Mobile cart opens drawer when available, avoiding mobile /cart route issues.
   - Cart +/- is optimistic: visible number updates immediately, server response
     still hard-syncs the cart.
   ============================================================ */
(function(){
  var D = document;
  function findAlpineCartApp(){
    var roots = D.querySelectorAll('[x-data]');
    for (var i = 0; i < roots.length; i++){
      var r = roots[i];
      var d = (r && r._x_dataStack && r._x_dataStack[0]) || (r && r.__x && r.__x.$data) || null;
      if (d && typeof d.cart_drawer !== 'undefined') return d;
    }
    return null;
  }
  window.srOpenCartDrawerOnMobile = function(){
    try {
      var app = findAlpineCartApp();
      if (!app) return false;
      app.cart_drawer = true;
      app.cart_alert = false;
      return true;
    } catch(e){ return false; }
  };

  D.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a.sr-mbar__cart[href]') : null;
    if (!a) return;
    if (window.srOpenCartDrawerOnMobile && window.srOpenCartDrawerOnMobile()) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }, true);

  function parseRange(s){
    if (window.srParseTierRange) { try { var r = window.srParseTierRange(s); if (r) return r; } catch(e){} }
    var m = String(s || '').trim().match(/^\s*(\d+)\s*[-–—]\s*(\d+)\s*$/);
    if (!m) return null;
    var a = parseInt(m[1],10), b = parseInt(m[2],10);
    return b >= a ? { min:a, max:b } : null;
  }
  function optimisticTarget(item, dir){
    dir = dir < 0 ? -1 : 1;
    var cur = parseInt(item && item.quantity, 10) || 0;
    var props = (item && item.properties) || {};
    var moq = parseInt(props._sr_moq || props._moq || 0, 10) || 0;
    var r = null;
    try {
      r = parseRange(item.variant_title) ||
          (item.variant_options && parseRange(item.variant_options[0])) ||
          (item.options_with_values && item.options_with_values[0] && parseRange(item.options_with_values[0].value));
    } catch(e){}
    var step = 1;
    if (r && !moq) step = Math.max(1, (r.max - r.min + 1));
    var next = cur + (dir * step);
    if (next < 0) next = 0;
    if (moq && next > 0 && next < moq) next = dir > 0 ? moq : 0;
    return next;
  }
  function adjustAppCount(delta){
    try {
      var roots = D.querySelectorAll('[x-data]');
      for (var i = 0; i < roots.length; i++){
        var r = roots[i];
        var d = (r && r._x_dataStack && r._x_dataStack[0]) || (r && r.__x && r.__x.$data) || null;
        if (d && d.cart && typeof d.cart.item_count !== 'undefined') {
          d.cart.item_count = Math.max(0, (parseInt(d.cart.item_count,10) || 0) + delta);
        }
      }
    } catch(e){}
  }
  var previousStep = window.srStepCartLine;
  window.srStepCartLine = function(item, dir){
    if (!item || !item.key) return previousStep ? previousStep(item, dir) : undefined;
    dir = dir < 0 ? -1 : 1;
    var oldQty = parseInt(item.quantity, 10) || 0;
    var nextQty = optimisticTarget(item, dir);
    var requestItem = {};
    try { for (var k in item) { if (Object.prototype.hasOwnProperty.call(item,k)) requestItem[k] = item[k]; } } catch(e) { requestItem = item; }
    requestItem.quantity = oldQty;
    try { item.quantity = nextQty; } catch(e){}
    adjustAppCount(nextQty - oldQty);
    try { window.srSuppressCartToastUntil = Date.now() + 1600; } catch(e){}
    if (typeof previousStep === 'function') return previousStep(requestItem, dir);
  };
})();
